// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T15:53:41.627Z
// Property: Parc at Roxbury (ID: 6767906449166337)
// Collections: 39 amenities, 15 floorplans (live), 22 photos, 76 POIs, 2 reviews, 1 virtual tours, 6 office hours, 3 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166337",
  "property_external_id": "30935",
  "property_zillow_url": "https://www.zillow.com/apartments/ledgewood-nj/parc-at-roxbury/CgGpvw/",
  "property_apartments_url": "https://www.apartments.com/parc-at-roxbury-ledgewood-nj/44edgwk/",
  "property_google_business_url": "https://www.google.com/maps/place/Parc+at+Roxbury+Apartment+Homes/data=!4m2!3m1!1s0x0:0xb1209453ec673de3?sa=X&ved=2ahUKEwjVsu7x07iSAxXCrokEHdyJG-wQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "parc-at-roxbury",
  "property_name": "Parc at Roxbury",
  "property_website_url": "https://www.parcatroxbury.com/",
  "property_domain": "https://www.parcatroxbury.com/",
  "property_address": "400 Cardinal Ct",
  "property_full_address": "400 Cardinal Ct, Ledgewood, NJ 07852",
  "property_address_1": "400 Cardinal Ct",
  "property_address_2": null,
  "property_address_city": "Roxbury Township",
  "property_address_state": "NJ",
  "property_address_zip_full": "07852-2615",
  "property_address_zip": "07852",
  "property_address_country": "US",
  "property_address_county": "Morris County",
  "property_neighborhood_address": "Ledgewood",
  "property_address_latitude": "40.8917156",
  "property_address_longitude": "-74.6915023",
  "property_email": "parcroxbury@aionmanagement.com",
  "property_phone": "(973) 928-8731",
  "property_call_tracking_phone": "844-779-9300",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Experience vibrant living at Parc at Roxbury, where stylish one and two-bedroom apartments meet modern amenities. Enjoy scenic walking trails, a state-of-the-art fitness center, and a lively pet-friendly atmosphere. With covered parking and EV charging, convenience is at your doorstep. Transform your lifestyle and find your new home today!",
  "property_long_description": "Welcome to Parc at Roxbury, where luxury meets comfort in beautiful Roxbury Township, NJ! Our apartment community boasts a variety of thoughtfully designed floor plans, including spacious one-bedroom and two-bedroom options, ensuring the perfect fit for any lifestyle. \n\nAt Parc at Roxbury, we prioritize your lifestyle with an impressive array of amenities. Enjoy sunny days on our walking and biking trails or take a leisurely stroll through our well-maintained courtyard. Our resort-style swimming pool and sundeck provide the ideal setting for relaxation, while our fitness center and yoga studio cater to your health and wellness needs. For those who enjoy social gatherings, our clubhouse is the perfect spot, complete with a theater/media room and game room for endless entertainment. \n\nWe also understand the importance of convenience, which is why we offer covered parking, EV charging stations, and an online resident portal to manage your day-to-day tasks with ease. Pet owners will love our dog park and pet wash station, ensuring that your furry friends feel right at home. Plus, with features like flex rent payments and controlled access, you can experience peace of mind in every aspect of your living environment.\n\nDiscover the ultimate blend of style, community, and convenience at Parc at Roxbury. Whether you’re looking for short-term leases, a vibrant resident program, or a place to unwind, our community has it all. Don’t wait any longer to find your new home—explore our availability or schedule a tour today! ",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd955-5a7e-7768-98f3-9364fe0d5d89.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside apartment buildings.",
    "public_id": "019fd955-5a7e-7768-98f3-9364fe0d5d89",
    "storage_key": "property/6767906449166337/019fd955-5a7e-7768-98f3-9364fe0d5d89.webp",
    "width": 1920,
    "height": 1279
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "231",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.40259740259741",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "We allow dogs, cats, and service animals (all must be housebroken; no breeding). Restricted dog breeds include German Shepherds, Akitas, Chow mixes, American Bulldogs, Staffordshire Terriers, Dobermans (mini pinschers allowed), Rottweilers, wolf-dog hybrids, Pit Bulls, Presa Canario, and Canary dogs (50% or more mix). Maximum of two pets per unit. No weight restrictions.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://parcatroxbury.loftliving.com/login",
  "property_apply_now_url": "https://www.parcatroxbury.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-7463-747f-a11e-f123e3cfff5b.webp",
  "property_primary_logo_media": {
    "alt_text": "Parc at Roxbury logo.",
    "public_id": "019d0268-7463-747f-a11e-f123e3cfff5b",
    "storage_key": "property/6767906449166337/019d0268-7463-747f-a11e-f123e3cfff5b.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026b-0c70-730f-9716-ce234ca1dbbf.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION Management logo",
    "public_id": "019d026b-0c70-730f-9716-ce234ca1dbbf",
    "storage_key": "property/6767906449166337/019d026b-0c70-730f-9716-ce234ca1dbbf.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026b-209c-7447-a2f5-85c59df38a23.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Parc at Roxbury logo",
    "public_id": "019d026b-209c-7447-a2f5-85c59df38a23",
    "storage_key": "property/6767906449166337/019d026b-209c-7447-a2f5-85c59df38a23.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d026b-297c-7005-a8b4-a01752f9f855.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Parc at Roxbury logo",
    "public_id": "019d026b-297c-7005-a8b4-a01752f9f855",
    "storage_key": "property/6767906449166337/019d026b-297c-7005-a8b4-a01752f9f855.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "737 - 1210",
  "property_sqft_min": "737",
  "property_sqft_max": "1210",
  "property_price_range": "1076 - 3099",
  "property_price_min": "1076",
  "property_price_max": "3099",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/parcatroxbury/",
  "property_instagram_url": "https://www.instagram.com/parcatroxbury",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHzdk7fV1w4kR4z1n7FOUILE",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=3+Bedroom+Apartment+Rental&find_loc=Netcong%2C+NJ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Parc at Roxbury",
  "property_home_romance_title": "Embrace Your New Life in Our Charming Community  \n",
  "property_home_amenities_blurb": "Welcome to Parc at Roxbury, where modern living meets nature. Choose from spacious one or two-bedroom floor plans and indulge in amenities like walking trails, a sparkling swimming pool, and a vibrant clubhouse. Enjoy a pet-friendly lifestyle with a dog park and relax in our outdoor lounge. Your new home awaits!",
  "property_home_floorplans_blurb": "At Parc at Roxbury, your ideal home awaits amidst spacious one and two-bedroom layouts designed for modern living. Nestled in the heart of Roxbury Township, NJ, our community blends comfort with style. Browse our available apartment homes today and let us help you find the perfect floor plan tailored to your lifestyle!",
  "property_home_gallery_blurb": "At Parc at Roxbury, experience a lifestyle brimming with comfort and convenience. Choose from spacious one- and two-bedroom floor plans while indulging in amenities like a refreshing swimming pool, yoga studio, and a vibrant community clubhouse. Picture yourself embracing outdoor trails and cozy fire pits in picturesque Roxbury Township, NJ.",
  "property_home_neighborhood_blurb": "Welcome to Parc at Roxbury, where modern living meets vibrant community life. Nestled in scenic Roxbury Township, our apartments offer a perfect blend of comfort and convenience. Enjoy local charm with nearby destinations like Horseshoe Lake Recreation Complex, County College of Morris, and Morris Canal Park, creating endless opportunities for leisure and exploration.",
  "property_home_reviews_blurb": "At Parc at Roxbury, community comfort meets exceptional service. Residents rave about our “thorough, efficient, and timely” maintenance team, ensuring every need is met. Enjoy spacious amenities, serene walking trails, and a welcoming neighborhood—all contributing to the perfect living experience in Roxbury Township, NJ. Join our thriving community today!",
  "property_neighborhood_blurb": "Nestled in the heart of Roxbury Township, Parc at Roxbury offers convenience at every corner. Stroll through scenic parks, visit historic sites like Waterloo Village, or catch a show at the Mayo Performing Arts Center. With top schools and fitness centers nearby, your vibrant lifestyle awaits! ",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Parc at Roxbury, where comfort meets convenience in the heart of Roxbury Township, NJ. Choose from stylish one and two-bedroom floor plans, all while enjoying an array of amenities like a refreshing swimming pool, modern fitness center, and vibrant community spaces. Join us today!",
  "property_applynow_blurb": "At Parc at Roxbury, your perfect living space awaits with one and two-bedroom floor plans designed for comfort and convenience. Enjoy modern amenities like a fitness center, outdoor lounge, and pet-friendly options, along with walking trails just outside your door. Lease online today and experience the vibrant lifestyle you deserve!",
  "property_contactus_blurb": "At Parc at Roxbury, we offer thoughtfully designed one- and two-bedroom apartments that cater to your lifestyle. Nestled in peaceful Roxbury Township, NJ, our community combines modern comfort with convenient amenities. Have questions? Our leasing team is ready to assist you in finding your perfect home!",
  "property_faqs_blurb": "At Parc at Roxbury, discover your perfect fit with our thoughtfully designed one and two-bedroom floor plans. Nestled in scenic Roxbury Township, NJ, our FAQs page is your go-to resource for all things community-related. Uncover the answers you need for a seamless living experience today!",
  "property_floorplans_blurb": "At Parc at Roxbury, we offer thoughtfully designed floor plans to suit your lifestyle. Whether you crave the cozy charm of a one-bedroom retreat or the spacious comfort of a two-bedroom haven, each layout is crafted for modern living. Browse our available apartment homes and envision your ideal space today!",
  "property_gallery_blurb": "At Parc at Roxbury, where comfort meets community, envision your future in stylish one or two-bedroom apartments. Indulge in exceptional amenities like a serene outdoor lounge, vibrant game room, and a refreshing swimming pool. Let your imagination run wild—picture yourself living here and savoring every moment!",
  "property_interactivemap_blurb": "At Parc at Roxbury, the perfect blend of relaxation and activity awaits. Choose from our stylish one or two-bedroom floor plans and enjoy amenities like a refreshing swimming pool, state-of-the-art fitness center, and pet-friendly spaces. Ready to find your ideal home? Utilize our interactive community map today!",
  "property_pets_blurb": "Welcome to Parc at Roxbury, where comfort meets community in picturesque Roxbury Township, NJ. Embrace a vibrant lifestyle alongside your furry companions—our pet-friendly policy welcomes dogs and cats, ensuring they feel at home too. Enjoy spacious living and scenic surroundings perfect for both you and your pets!",
  "property_referafriend_blurb": "At Parc at Roxbury, our vibrant apartment community offers thoughtfully designed one and two-bedroom floor plans to suit your lifestyle. Great friends make great neighbors—refer a friend to join you in this welcoming atmosphere. Together, you can create lasting memories in beautiful Roxbury Township, NJ!",
  "property_residentaccess_blurb": "At Parc at Roxbury, your dream apartment awaits! Choose from spacious one and two-bedroom floor plans designed for your lifestyle. Enhance your living experience in beautiful Roxbury Township, NJ. Ready to simplify your life? Access your resident portal to pay rent, schedule maintenance, and more—all at your fingertips!",
  "property_reviews_blurb": "At Parc at Roxbury, our residents rave about the exceptional maintenance and friendly service from our team. With reviews highlighting our “thorough, efficient, and timely” support, you’ll find comfort in our well-maintained community. Enjoy quiet living near scenic trails, playful dog runs, and inviting social spaces. Experience it for yourself!",
  "property_created_at": "1757008801733",
  "property_scheduletour_blurb": "At Parc at Roxbury, find your ideal oasis with stylish one and two-bedroom floor plans designed for modern living. Nestled in the heart of Roxbury Township, NJ, our vibrant community offers more than just a home—it's a lifestyle. Curious? Schedule a tour and hear directly from our satisfied residents!",
  "property_thankyou_blurb": "Thank you for reaching out to Parc at Roxbury! Nestled in beautiful Roxbury Township, NJ, we offer spacious one and two-bedroom floor plans designed for your comfort. Our team is excited to connect with you soon and help you discover your ideal home in our vibrant community.",
  "property_virtualtours_blurb": "Welcome to Parc at Roxbury, where comfort meets style in Roxbury Township, NJ. Choose from our thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and discover your future oasis today!",
  "property_copyright": "2025 All Rights Reserved. Parc at Roxbury",
  "property_seo_title_home": "Parc at Roxbury |  Apartments in Roxbury Township, NJ",
  "property_seo_description_home": "Elevate your lifestyle at Parc at Roxbury! Enjoy modern living, extensive amenities, stunning floor plans, and a pet-friendly community.",
  "property_seo_title_floorplans": "Floor Plans | Roxbury Township, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Parc at Roxbury, NJ! Choose from stylish one or two-bedroom floor plans. Your dream home awaits—browse our options today!",
  "property_seo_title_amenities": "Amenities | Roxbury Township, NJ Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Parc at Roxbury, where delightful amenities meet comfort. Enjoy trails, a pool, and pet-friendly spaces in the heart of Roxbury, NJ.",
  "property_seo_title_gallery": "Gallery | Apartments in Roxbury Township, NJ",
  "property_seo_description_gallery": "Picture your life at Parc at Roxbury! Enjoy modern amenities, serene trails, and a vibrant community in Roxbury Township, NJ. Your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Parc at Roxbury Apartments",
  "property_seo_description_virtualtours": "Experience Parc at Roxbury, where stylish one and two-bedroom apartments await. Take a virtual tour today and envision your new home in Roxbury Township, NJ!",
  "property_seo_title_interactivemap": "Interactive Map | Parc at Roxbury Apartments",
  "property_seo_description_interactivemap": "Discover luxury living at Parc at Roxbury! Use our interactive map to find your ideal one or two-bedroom apartment with top-notch amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Roxbury Township, NJ",
  "property_seo_description_neighborhood": "Uncover the charm of Roxbury Township at Parc at Roxbury! Delight in local favorites and vibrant attractions just steps from your door.",
  "property_seo_title_contact": "Contact Us | Parc at Roxbury",
  "property_seo_description_contact": "Elevate your lifestyle at Parc at Roxbury! Choose from spacious one and two-bedroom floor plans. Questions? Our leasing team is ready to assist you today!",
  "property_seo_title_faqs": "FAQs | Apartments in Roxbury Township, NJ",
  "property_seo_description_faqs": "Uncover answers to your top questions about life at Parc at Roxbury. From amenities to plans, we're here to guide you through our welcoming community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Roxbury Township, NJ",
  "property_seo_description_reviews": "Life at Parc at Roxbury offers more than just a home. Dive into resident reviews and see why our vibrant amenities and community spirit make us special!",
  "property_seo_title_applynow": "Apply Now | Apartments in Roxbury Township, NJ",
  "property_seo_description_applynow": "Find your perfect sanctuary at Parc at Roxbury! Enjoy luxurious amenities, spacious floor plans, and a vibrant community. Apply online and make it yours today!",
  "property_seo_title_residentaccess": "Resident Access | Parc at Roxbury",
  "property_seo_description_residentaccess": "Effortlessly manage your home at Parc at Roxbury. Log in to your resident portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Parc at Roxbury",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Parc at Roxbury and unlock exclusive rewards while building a vibrant community in Roxbury Township, NJ.",
  "property_seo_title_scheduletour": "Schedule a Tour | Parc at Roxbury",
  "property_seo_description_scheduletour": "Experience the charm of Parc at Roxbury. Schedule your tour today to discover your future home in beautiful Roxbury Township, NJ—where comfort meets style!",
  "property_seo_title_privacy": "Privacy Policy | Parc at Roxbury",
  "property_seo_description_privacy": "Your privacy matters at Parc at Roxbury. Dive into our policy to see how we safeguard your information while you enjoy vibrant living in Roxbury Township, NJ.",
  "property_seo_title_accessibility": "Website Accessibility | Parc at Roxbury",
  "property_seo_description_accessibility": "At Parc at Roxbury, we prioritize accessibility for all. Check our statement to ensure every resident can enjoy our community in Roxbury Township, NJ.",
  "property_seo_title_sitemap": "Sitemap | Parc at Roxbury",
  "property_seo_description_sitemap": "Navigate through Parc at Roxbury's offerings in Roxbury Township, NJ! Find your perfect home with ease—check out our sitemap for details and amenities.",
  "property_seo_title_thankyou": "Thank You | Parc at Roxbury",
  "property_seo_description_thankyou": "Thank you for reaching out to Parc at Roxbury! Your next home awaits. Our team will connect with you soon to discuss your future in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Roxbury Township, NJ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293626699",
  "amenities": [
    {
      "id": "custom_8e4e22cd-e93c-45de-b839-ef902bf520b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ff30b2d6-1eb0-46e9-8b36-4ef2967149da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06b8f7d8-ca56-4f00-b87c-bc69ef6de5cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f36ffb6d-174c-41a2-99a3-9ff78e5971c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled-Access Building",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b63339a9-60e0-4b69-9b34-2b38c2ae2a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d053b691-712f-4d3e-8b14-d5780191db56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center with Peloton Bikes",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7365bd11-6f6a-4414-bc51-58abffc46cf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f6f8280-737c-4ac7-9740-2358cfe9f795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Indoor Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eaf0cd6e-0152-4f7e-823f-ace5349db457",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb65b5e7-15df-405b-84dd-f9e0246457c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec3e2305-474b-473d-881d-e2e4b84b27c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7e7c88ae-1393-46bd-b6fd-c9755d5fa1f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6f46707-4d39-457d-911e-a96bedac9ce1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1fd0eb95-8512-4757-906f-bf2be7c22889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Wash",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24aef8f5-96fc-4c63-a776-41e9cc9a63ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5691f9a9-7515-4368-aadd-52e0250353ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Secure Package Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_509b46e5-72b1-4379-8425-8b8c030c2331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5ada8622-7074-4c3d-982a-96e7ab431fad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Virtual Fitness Studio",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92f3b12f-daa7-40d8-b077-b1b118640842",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "WiFi in Common Areas",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae67abc6-9108-496e-b1f8-e0428b56e149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Bath w/ Quartz Countertop & Spacious Dual-Sink Vanity",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_faafbd5f-8bbd-46cd-8092-c1981bc9e954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Dens Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fffdda41-3fbc-40ae-8295-3d1f8c294fc6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Full-Size Front-Loading Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48b6134d-6562-473a-939c-22047609bbb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Shower/Tub",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f7bf754-63cf-41da-9fd8-f0a00df4f8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Pre-Wired for Wall-Mount Flat-Screen TVs",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_61613a05-1caf-4560-90ca-f7ab2105bf8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios or Balconies Available",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f8af193-2129-409c-b506-a826559decb5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops & Glass Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42f129b3-9515-4e7d-8b2d-1a0ebd63f05f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcf755f5-69a7-4d1b-b491-9662b611517c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_056debea-72be-43d0-9cef-9a45b766cdbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Walk-In Closet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ec8731b-b153-46be-8bb3-1b2021325900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Plank Floors",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c1a8707-a85f-4509-8572-4de35c939d97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Walking & Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c193d8d9-3591-4996-a83e-7adc24378a39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "1 & 2 Bedroom Apartments",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_887f6d1d-e360-4195-8de2-98f51502724d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77c4a292-4fa6-4b87-af32-09f8f9814b6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23f3aa84-b7af-425d-a8cf-4cb668a2c8b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f5c8ef0f-482d-4b61-a91a-5de87709e3fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fireplace with Lounge Seating",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b536b597-21c6-40c4-9db5-f46cb1c8e844",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool with Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95b80de2-cfd5-4664-89af-04e14d791f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Two Dog Parks",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d4de1d11-fc5d-42ff-8520-7a2201251e03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "external_id": "false",
      "title": "Sound-Absorbing Construction Technology",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0603453c-9a77-4ac4-858c-c5b9dacc9dc2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-7cb4-7183-8578-20c617ecfaac.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and an island with bar stools.",
        "public_id": "019fd957-7cb4-7183-8578-20c617ecfaac",
        "storage_key": "property/6767906449166337/019fd957-7cb4-7183-8578-20c617ecfaac.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "",
      "alt_text": "Open-concept kitchen with island, dark cabinets, and stainless steel appliances beside the living area at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/73f3fb8afd8becf1ce070ed36c6062a7-1920w.jpg"
    },
    {
      "id": "custom_5c6baf3a-10f6-4c5e-8f43-b26c6dfd12fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-8b28-777c-a696-60558f38374a.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet with storage baskets and towels.",
        "public_id": "019fd957-8b28-777c-a696-60558f38374a",
        "storage_key": "property/6767906449166337/019fd957-8b28-777c-a696-60558f38374a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit laundry closet with side-by-side front-load machines, towels, and woven baskets on organized shelves.",
      "link": "",
      "alt_text": "In-unit laundry closet with two front-loading washers and a dryer; white wire shelves hold towels and baskets at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/638ab9cef7f95ea0dad79014fb274cf7-1920w.jpg"
    },
    {
      "id": "custom_7a7cc7e6-acb9-4034-bb82-b6d6cf9beddc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-93b7-760c-b283-3b6d44e88375.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex swimming pool and lounge area",
        "public_id": "019fd957-93b7-760c-b283-3b6d44e88375",
        "storage_key": "property/6767906449166337/019fd957-93b7-760c-b283-3b6d44e88375.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Resort-style outdoor pool at a modern apartment community, lined with umbrellas and lounge chairs.",
      "link": "",
      "alt_text": "Outdoor pool area at an apartment community with teal umbrellas and lounge chairs at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/cbc9b2c72e8958a259e3b66f27c353c5-1920w.jpg"
    },
    {
      "id": "custom_bce9eabb-6655-4c2a-adb6-94498d380a00",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-961b-75dc-a30b-c25c582aa4fd.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019fd957-961b-75dc-a30b-c25c582aa4fd",
        "storage_key": "property/6767906449166337/019fd957-961b-75dc-a30b-c25c582aa4fd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious outdoor pool area at an apartment community, with lounge chairs and surrounding residential buildings.",
      "link": "",
      "alt_text": "Outdoor pool area of apartment community with lounge chairs and buildings at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/00d7c962f2d526d1d4083452819089b6-1920w.jpg"
    },
    {
      "id": "custom_bbf30f9e-7aea-4aa4-afb7-09498fa540b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-9c8f-709d-b002-b4bf5e7dc585.webp",
      "image_media": {
        "alt_text": "Community kitchen with island seating and coffee station.",
        "public_id": "019fd957-9c8f-709d-b002-b4bf5e7dc585",
        "storage_key": "property/6767906449166337/019fd957-9c8f-709d-b002-b4bf5e7dc585.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "A modern open-concept community kitchen with a large marble island, six stools, pendant lighting, and a coffee bar.",
      "link": "",
      "alt_text": "Open-concept community kitchen with marble island, pendant lights, and outdoor doors at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/936ad0248ac52516e80a4f003c8e2b3a-1920w.jpg"
    },
    {
      "id": "custom_be42e8ec-b8d4-492e-b8e3-ee74a4881339",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-9f78-733f-8865-2c12e7cfe402.webp",
      "image_media": {
        "alt_text": "Clubhouse lounge area with fireplace, TV, sectional sofa, and dining table overlooking the pool.",
        "public_id": "019fd957-9f78-733f-8865-2c12e7cfe402",
        "storage_key": "property/6767906449166337/019fd957-9f78-733f-8865-2c12e7cfe402.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Featured",
      "link": "",
      "alt_text": "Spacious community lounge with a large sectional, armchairs, TV, and a fireplace at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/64ae5dc4a8c4fe6070ec9d33498217d9-1920w.jpg"
    },
    {
      "id": "custom_4b2f5595-441f-4c3c-bcd2-091935212603",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-a2b4-7086-8d76-f7958010089e.webp",
      "image_media": {
        "alt_text": "Conference room with a large table, chairs, and a TV.",
        "public_id": "019fd957-a2b4-7086-8d76-f7958010089e",
        "storage_key": "property/6767906449166337/019fd957-a2b4-7086-8d76-f7958010089e.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Modern community conference room at the property featuring a long table, wall-mounted TV, and contemporary artwork.",
      "link": "",
      "alt_text": "Conference room with a rectangular table, wall-mounted TV, chairs, and framed artwork at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/dc043886473a945a845fc0c3ab6f97dc-1920w.jpg"
    },
    {
      "id": "custom_1c136785-f0d0-43e5-8868-ee75746f972c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fd957-aa9f-7737-a175-19ea6a1d4596.webp",
      "image_media": {
        "alt_text": "Community lounge area with pool table, shuffleboard, TV, and kitchen island.",
        "public_id": "019fd957-aa9f-7737-a175-19ea6a1d4596",
        "storage_key": "property/6767906449166337/019fd957-aa9f-7737-a175-19ea6a1d4596.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Inviting clubhouse with a pool table, granite island, contemporary lighting, and ample seating for residents.",
      "link": "",
      "alt_text": "Modern community lounge with a pool table, granite island, pendant lighting, and glass entry doors at The Parc at Roxbury in Roxbury, NJ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/45d33f2b/dms3rep/multi/opt/5767906449162442/6767906449166337/0b05e230cd8a333ce11189db517ef4d4-1920w.jpg"
    },
    {
      "id": "custom_0623a3d3-0fd8-4b15-ab4a-de01b1cf2733",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-938c-75e1-9eed-ead023f68b0e.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and large sliding glass door leading to a patio.",
        "public_id": "01a19cdd-938c-75e1-9eed-ead023f68b0e",
        "storage_key": "property/6767906449166337/01a19cdd-938c-75e1-9eed-ead023f68b0e.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, a stylish marble coffee table, and a large sliding glass door that opens to a private patio area.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and large sliding glass door leading to a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7e1790c-b290-4cde-b66a-baa8c27f5519",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-8a42-7186-b716-550c385841a5.webp",
      "image_media": {
        "alt_text": "Modern apartment complex gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "01a19cdd-8a42-7186-b716-550c385841a5",
        "storage_key": "property/6767906449166337/01a19cdd-8a42-7186-b716-550c385841a5.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and free weights for residents.",
      "link": "",
      "alt_text": "Modern apartment complex gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_967db1ef-62a5-4f68-9faf-005a9db45cc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-859d-71c8-bdfe-ec9e4698f8ae.webp",
      "image_media": {
        "alt_text": "Luxury bedroom with a king-size bed, decorative pillows, and a tray with wine glasses on the bed.",
        "public_id": "01a19cdd-859d-71c8-bdfe-ec9e4698f8ae",
        "storage_key": "property/6767906449166337/01a19cdd-859d-71c8-bdfe-ec9e4698f8ae.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor. A perfect sanctuary after a long day.",
      "link": "",
      "alt_text": "Luxury bedroom with a king-size bed, decorative pillows, and a tray with wine glasses on the bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91e88459-ba0f-41e4-9d8a-878d99ea2770",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-8af0-7243-8b75-aa795bf225ee.webp",
      "image_media": {
        "alt_text": "Communal lounge area with a fireplace, TV, dining table, and comfortable seating.",
        "public_id": "01a19cdd-8af0-7243-8b75-aa795bf225ee",
        "storage_key": "property/6767906449166337/01a19cdd-8af0-7243-8b75-aa795bf225ee.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Relax and socialize in the communal lounge, featuring a cozy fireplace, entertainment center, and a large dining table perfect for gatherings.",
      "link": "",
      "alt_text": "Communal lounge area with a fireplace, TV, dining table, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_13247237-6674-49d7-8f05-0f874c05227c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-7932-772f-b659-0a3a4e21fd70.webp",
      "image_media": {
        "alt_text": "Luxurious king-size bed with tufted headboard and plush bedding in a well-decorated bedroom.",
        "public_id": "01a19cdd-7932-772f-b659-0a3a4e21fd70",
        "storage_key": "property/6767906449166337/01a19cdd-7932-772f-b659-0a3a4e21fd70.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed and elegant decor. A perfect retreat.",
      "link": "",
      "alt_text": "Luxurious king-size bed with tufted headboard and plush bedding in a well-decorated bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b66286dd-86d8-4db0-88d9-f4d078108a1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-7cf8-758b-b2ff-b06d720052a7.webp",
      "image_media": {
        "alt_text": "Bathroom with a white bathtub, vanity, and toilet. Modern black cabinetry and subway tile.",
        "public_id": "01a19cdd-7cf8-758b-b2ff-b06d720052a7",
        "storage_key": "property/6767906449166337/01a19cdd-7cf8-758b-b2ff-b06d720052a7.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white soaking tub, a sleek vanity with a vessel sink, and a toilet. Elegant subway tile and dark cabinetry add a touch of sophistication.",
      "link": "",
      "alt_text": "Bathroom with a white bathtub, vanity, and toilet. Modern black cabinetry and subway tile.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0fdd5844-5ebe-483c-be24-d1e7e1a1cb05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-5928-74e8-b795-e220523ee62f.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table and bar.",
        "public_id": "01a19cdd-5928-74e8-b795-e220523ee62f",
        "storage_key": "property/6767906449166337/01a19cdd-5928-74e8-b795-e220523ee62f.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Enjoy a game of pool in our resident lounge, complete with a full-service bar area.",
      "link": "",
      "alt_text": "Community lounge area with a pool table and bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f67f191-0b13-43b2-a0c9-b76f9e5a18c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-57c2-742b-9316-fe277893bfab.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower, and toilet.",
        "public_id": "01a19cdd-57c2-742b-9316-fe277893bfab",
        "storage_key": "property/6767906449166337/01a19cdd-57c2-742b-9316-fe277893bfab.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with ample counter space, a sleek walk-in shower with glass doors, and a contemporary toilet.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, walk-in shower, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_74c673d2-d7f2-46c3-9284-99f967d50dd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-5365-7167-972e-e6751dd4bfc1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with pendant lighting.",
        "public_id": "01a19cdd-5365-7167-972e-e6751dd4bfc1",
        "storage_key": "property/6767906449166337/01a19cdd-5365-7167-972e-e6751dd4bfc1.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Apartment",
      "description": "Experience culinary perfection in this stunning modern kitchen, featuring sleek dark wood cabinetry, premium stainless steel appliances, and a spacious island perfect for meal prep and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a large island with pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_36ecb060-7b3f-4b5f-b484-05fee66339f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cdd-45e0-75af-8c41-d810cf9a6850.webp",
      "image_media": {
        "alt_text": "Theater room with comfortable reclining chairs and large screen TV.",
        "public_id": "01a19cdd-45e0-75af-8c41-d810cf9a6850",
        "storage_key": "property/6767906449166337/01a19cdd-45e0-75af-8c41-d810cf9a6850.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Enjoy movie nights or game days in our state-of-the-art theater room, complete with plush seating and a big screen.",
      "link": "",
      "alt_text": "Theater room with comfortable reclining chairs and large screen TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef46c604-5932-42ad-9881-cc5d39c5faf3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a11cb8-8650-77cb-8483-d12c1bcac83e.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with artificial turf and white picket fencing.",
        "public_id": "01a11cb8-8650-77cb-8483-d12c1bcac83e",
        "storage_key": "property/6767906449166337/01a11cb8-8650-77cb-8483-d12c1bcac83e.webp",
        "width": 1206,
        "height": 678
      },
      "title": "Community",
      "description": "Enjoy our pet-friendly community with a dedicated dog park for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Fenced-in dog park with artificial turf and white picket fencing.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e886e524-6997-404f-b394-0481ebe2e242",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a19cf4-4112-72d8-9cdb-6124bf5cdb61.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and green space.",
        "public_id": "01a19cf4-4112-72d8-9cdb-6124bf5cdb61",
        "storage_key": "property/6767906449166337/01a19cf4-4112-72d8-9cdb-6124bf5cdb61.webp",
        "width": 1908,
        "height": 1272
      },
      "title": "Community",
      "description": "An exterior view of modern apartment buildings, showcasing the property's architecture and amenities like ample parking and landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and green space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f4abb72-7666-49b7-bcd1-40b73c3783d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a11cb8-8528-77fd-b490-6ebefb8638c5.webp",
      "image_media": {
        "alt_text": "Grooming station with sink, dryer, and artwork of dogs.",
        "public_id": "01a11cb8-8528-77fd-b490-6ebefb8638c5",
        "storage_key": "property/6767906449166337/01a11cb8-8528-77fd-b490-6ebefb8638c5.webp",
        "width": 1252,
        "height": 704
      },
      "title": "Community",
      "description": "Pamper your pet at our on-site grooming station, equipped with a professional tub, dryer, and fun dog-themed artwork.",
      "link": "",
      "alt_text": "Grooming station with sink, dryer, and artwork of dogs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ca10220-671f-4d2b-9880-0616e4e212b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a11cb8-7d82-71e8-b9ef-5dd36aa68fc4.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with grilling station, tables, chairs, and umbrellas.",
        "public_id": "01a11cb8-7d82-71e8-b9ef-5dd36aa68fc4",
        "storage_key": "property/6767906449166337/01a11cb8-7d82-71e8-b9ef-5dd36aa68fc4.webp",
        "width": 994,
        "height": 559
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community grilling station, complete with comfortable seating and umbrellas for shade. Perfect for gatherings with friends and neighbors.",
      "link": "",
      "alt_text": "Outdoor patio area with grilling station, tables, chairs, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_eeea4ffc-54ca-4fe5-8d35-6e5a05cf6b61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Roosters Coffeehouse",
      "poi_type": "Restaurants",
      "poi_address": "202 Main St, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Family-owned coffee shop and eatery serving lattes, sandwiches and hot cacao in a cozy space.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-f3ef-7446-93ee-2dccee2e7905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-f3ef-7446-93ee-2dccee2e7905",
        "storage_key": "property/6767906449166337/019d0268-f3ef-7446-93ee-2dccee2e7905.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://roosterscoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17695126598784836853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosters-coffeehouse",
      "poi_latitude": "40.8773108",
      "poi_longitude": "-74.6512295",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-446-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-747f-75eb-bf7c-006238aa6ca5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-747f-75eb-bf7c-006238aa6ca5",
        "storage_key": "property/6767906449166337/019d0269-747f-75eb-bf7c-006238aa6ca5.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJk3TDNqyfw4kR9eQiiOO3kfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_19f817b9-f61e-4bf8-83e2-7a87a784de03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Giancarlo's Bakery",
      "poi_type": "Restaurants",
      "poi_address": "410 NJ-10, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Bakery specializing in Italian-style cakes, pastries, and deli items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-f5cc-734d-ae85-0207372220ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-f5cc-734d-ae85-0207372220ee",
        "storage_key": "property/6767906449166337/019d0268-f5cc-734d-ae85-0207372220ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://giancarlosbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13326992702199239199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "giancarlos-bakery",
      "poi_latitude": "40.8744048",
      "poi_longitude": "-74.6477312",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-252-5051",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Re7GjGew4kRHxLP0kD98rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_dd7ebf6a-6141-4e2a-839e-8025f43abe40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Roxbury Bagel & Deli",
      "poi_type": "Restaurants",
      "poi_address": "111 NJ-10, Succasunna, NJ 07876, USA",
      "poi_short_description": "Bagel shop in Succasunna offering breakfast, sandwiches, and sushi.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-f5cc-734d-ae84-fe884505e8d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-f5cc-734d-ae84-fe884505e8d7",
        "storage_key": "property/6767906449166337/019d0268-f5cc-734d-ae84-fe884505e8d7.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.roxburybagelsanddeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8288431568103812003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roxbury-bagel--deli",
      "poi_latitude": "40.8647259",
      "poi_longitude": "-74.6363935",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-927-0112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1V3k7Wfw4kRoyv24ZhsBnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bagel_shop"
    },
    {
      "id": "custom_33e560a8-aae8-4bb5-90b6-4c809645bb6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Ledgewood Farm",
      "poi_type": "Restaurants",
      "poi_address": "1013 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Produce market known for fresh fish and seafood along with deli items and flowers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-f593-732d-a642-db9046deea99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-f593-732d-a642-db9046deea99",
        "storage_key": "property/6767906449166337/019d0268-f593-732d-a642-db9046deea99.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://m.facebook.com/pages/Ledgewood-Farm/100280760033378",
      "poi_directions_map_url": "https://maps.google.com/?cid=13396691217030266276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ledgewood-farm",
      "poi_latitude": "40.8807988",
      "poi_longitude": "-74.6449152",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-598-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-9592bfa4d3cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-9592bfa4d3cc",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-9592bfa4d3cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_EJTSyew4kRpD2v5K6b6rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_45019146-966d-4b6e-a3d4-cf9b084e9bc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Outback Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1070 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_long_description": "Boisterous Australian-themed chain serving steaks, seafood & other hearty steakhouse fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fc4b-7540-b686-679578885b57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-fc4b-7540-b686-679578885b57",
        "storage_key": "property/6767906449166337/019d0268-fc4b-7540-b686-679578885b57.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.outback.com/new-jersey/ledgewood/1070-us-highway-46?utm_source=gmb&utm_medium=local_search&utm_campaign=website_cta&y_source=1_MTU1MDIyNjYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1364146477811652167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "outback-steakhouse",
      "poi_latitude": "40.8783645",
      "poi_longitude": "-74.6470413",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-927-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM1ZrZC6ew4kRR1aQd_5r7hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_d5497db3-4778-4d6a-aa3e-2442850ee72a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Cliff's Homemade Ice Cream",
      "poi_type": "Restaurants",
      "poi_address": "1475 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Old-school ice cream stand turning out 60+ flavors in no-frills digs with outdoor picnic tables.",
      "poi_long_description": "Old-school ice cream stand turning out 60+ flavors in no-frills digs with outdoor picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fdaf-7580-8f16-88906140c655.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-fdaf-7580-8f16-88906140c655",
        "storage_key": "property/6767906449166337/019d0268-fdaf-7580-8f16-88906140c655.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cliffsicecream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2491944811938194822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cliffs-homemade-ice-cream",
      "poi_latitude": "40.8879159",
      "poi_longitude": "-74.66148749999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-584-9721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyw5EiCew4kRhiV0g5oqlSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_583da693-f0ee-4dd0-a87a-d0863f365e15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "La Gratella Pizza & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "450 NJ-10, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Casual eatery supplying pizza, pasta, and other Italian dishes, plus catering.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fe07-726f-989c-f8e7c70eca3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-fe07-726f-989c-f8e7c70eca3b",
        "storage_key": "property/6767906449166337/019d0268-fe07-726f-989c-f8e7c70eca3b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lagratellapizzanj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17741991363540598854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-gratella-pizza--restaurant",
      "poi_latitude": "40.8751364",
      "poi_longitude": "-74.648394",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-970-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmU7prTGew4kRRsDi3yQ3OPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_9adfaf23-58fa-4f31-82ee-d143465c83af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Ichiban Japanese Cuisine & Catering",
      "poi_type": "Restaurants",
      "poi_address": "1034 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Japanese spot dishing up classic rolls, sashimi and tempura options, plus a sushi bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0268-fda3-772f-82ee-dda92e87ffe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0268-fda3-772f-82ee-dda92e87ffe4",
        "storage_key": "property/6767906449166337/019d0268-fda3-772f-82ee-dda92e87ffe4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ichibanroxbury.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14307933690328827321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ichiban-japanese-cuisine--catering",
      "poi_latitude": "40.8787294",
      "poi_longitude": "-74.64495099999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-252-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS7Z6fC6ew4kRucXkeeL9j8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_e9339987-3b55-4f9b-9241-0786cfc1bd74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Quality Inn Ledgewood - Dover",
      "poi_type": "Restaurants",
      "poi_address": "1691 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Unassuming hotel with a seasonal outdoor pool, plus freebies such as continental breakfast & WiFi.",
      "poi_long_description": "Unassuming hotel with a seasonal outdoor pool, plus freebies such as continental breakfast & WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-045c-70db-916a-75e93ace2d7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-045c-70db-916a-75e93ace2d7d",
        "storage_key": "property/6767906449166337/019d0269-045c-70db-916a-75e93ace2d7d.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.choicehotels.com/new-jersey/ledgewood/quality-inn-hotels/nj237?mc=llgoxxpx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14559870934903920317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quality-inn-ledgewood---dover",
      "poi_latitude": "40.8912852",
      "poi_longitude": "-74.6688613",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-440-2016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-748b-77ec-b4c4-91d3d8732591.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-748b-77ec-b4c4-91d3d8732591",
        "storage_key": "property/6767906449166337/019d0269-748b-77ec-b4c4-91d3d8732591.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJzc63_PV1w4kRvZZ7SnkND8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_6a8779a7-d65c-4d43-9701-283414fb6b9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Muldoon's",
      "poi_type": "Restaurants",
      "poi_address": "1447 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Neighborhood Irish pub doling out comfort food such as pot pie and burgers amid a lively atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-049c-709d-a2b5-50f8b0b414de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-049c-709d-a2b5-50f8b0b414de",
        "storage_key": "property/6767906449166337/019d0269-049c-709d-a2b5-50f8b0b414de.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.muldoonsirishpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3053012482080881040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "muldoons",
      "poi_latitude": "40.8872677",
      "poi_longitude": "-74.6605823",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-927-1951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7884-743f-9cc7-1d531eec7247.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7884-743f-9cc7-1d531eec7247",
        "storage_key": "property/6767906449166337/019d0269-7884-743f-9cc7-1d531eec7247.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8P7WCCew4kRkLlDSa16Xio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_20d78425-c302-4fc0-aac9-d588433d2a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Cinders Wood Fire Grill",
      "poi_type": "Restaurants",
      "poi_address": "319 US-46, Mine Hill Township, NJ 07803, USA",
      "poi_short_description": "This upscale, rustic-chic spot serves a menu of steaks, sushi & small plates.",
      "poi_long_description": "This upscale, rustic-chic spot serves a menu of steaks, sushi & small plates.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-045c-70db-916a-7a5dbb85508e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-045c-70db-916a-7a5dbb85508e",
        "storage_key": "property/6767906449166337/019d0269-045c-70db-916a-7a5dbb85508e.webp",
        "width": 400,
        "height": 267
      },
      "poi_business_url": "http://www.cinderswoodfiregrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4828705820741312077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinders-wood-fire-grill",
      "poi_latitude": "40.880184",
      "poi_longitude": "-74.6071702",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-928-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbe-r8uKfw4kRTZ4lQlwCA0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4336bb02-85f7-467e-b882-95abf94aecba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "461 NJ-10 Suite C100, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-06a9-748a-9c31-56bab6593c47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-06a9-748a-9c31-56bab6593c47",
        "storage_key": "property/6767906449166337/019d0269-06a9-748a-9c31-56bab6593c47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/nj/ledgewood/461-rte-10?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12697906623111585848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "40.8743876",
      "poi_longitude": "-74.650103",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-668-4184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw9skdCyfw4kROGClHcwGOLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0dedc1f7-970d-483a-a20b-3ac1de1a7499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Five Guys",
      "poi_type": "Restaurants",
      "poi_address": "461 NJ-10, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_long_description": "Fast-food chain with made-to-order burgers, fries & hot dogs, plus free peanuts while you wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-0aab-7001-a433-4b1178465350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-0aab-7001-a433-4b1178465350",
        "storage_key": "property/6767906449166337/019d0269-0aab-7001-a433-4b1178465350.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://restaurants.fiveguys.com/461-rt-10-east",
      "poi_directions_map_url": "https://maps.google.com/?cid=8422103719608303777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-guys",
      "poi_latitude": "40.8729069",
      "poi_longitude": "-74.6523029",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-617-1855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMfv1wsufw4kRocC_9LVS4XQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_2a6aa0d7-98b7-4954-882d-5c1a622fe2fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "461 NJ-10 STE# C200, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-0d15-77da-a541-d28a33d9721e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-0d15-77da-a541-d28a33d9721e",
        "storage_key": "property/6767906449166337/019d0269-0d15-77da-a541-d28a33d9721e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/nj/ledgewood/3399?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9594350015484736384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "40.8742631",
      "poi_longitude": "-74.6500645",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 848-800-8816",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-902b28db41f7",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-902b28db41f7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6Q3TCJafw4kRgDO7i4H6JYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_20e05060-67f6-4d9a-bf36-d89fc8be7f2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "461 NJ-10 Ste A100, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Vast retail store selling groceries and consumer electronics, as well as clothing, furniture and toys.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-0d18-702f-b9b8-a0620e559ad6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-0d18-702f-b9b8-a0620e559ad6",
        "storage_key": "property/6767906449166337/019d0269-0d18-702f-b9b8-a0620e559ad6.webp",
        "width": 1000,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3912-ledgewood-nj/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14312081327062036936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "40.8731787",
      "poi_longitude": "-74.6528447",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-598-4088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7880-7129-acf2-59a0748acae5",
        "storage_key": "property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJq6qqqh6ew4kRyLEIaCO6nsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b3e164f0-5eeb-440f-a419-85d6e52602e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "BJ's Wholesale Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "1 Howard Blvd, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Membership-only retail chain offering bulk groceries, electronics & more in a warehouse-like space.",
      "poi_long_description": "Membership-only retail chain offering bulk groceries, electronics & more in a warehouse-like space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-0f1d-732c-9d4e-2805add195ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-0f1d-732c-9d4e-2805add195ec",
        "storage_key": "property/6767906449166337/019d0269-0f1d-732c-9d4e-2805add195ec.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://www.bjs.com/cl/roxbury/0048/?trc=locl%7Cggmb%7Cweb%7Cxlob%7Cxlob%7Clocdist%7C0048%7Cstore%7C20240816",
      "poi_directions_map_url": "https://maps.google.com/?cid=1344222088935756527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bjs-wholesale-club",
      "poi_latitude": "40.8810571",
      "poi_longitude": "-74.64824910000002",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-252-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7880-7129-acf2-59a0748acae5",
        "storage_key": "property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJs7DUqYB1w4kR79I_Lt6ipxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_3598bae7-5e62-4b99-8cdc-cc2588684f7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "ShopRite of Succasunna",
      "poi_type": "Shopping & Retail",
      "poi_address": "275-281 NJ-10, Succasunna, NJ 07876, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-140b-741a-9ec8-cfdc48e7065a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-140b-741a-9ec8-cfdc48e7065a",
        "storage_key": "property/6767906449166337/019d0269-140b-741a-9ec8-cfdc48e7065a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=281",
      "poi_directions_map_url": "https://maps.google.com/?cid=14124882541774663588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-succasunna",
      "poi_latitude": "40.8674325",
      "poi_longitude": "-74.6481581",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-584-1322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7480-71fb-888a-9592bfa4d3cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7480-71fb-888a-9592bfa4d3cc",
        "storage_key": "property/6767906449166337/019d0269-7480-71fb-888a-9592bfa4d3cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg-SoWzGew4kRpG-YvNWpBcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5837eb59-eb96-4418-b4a5-c55148e7596a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Ronetco Supermarkets Inc",
      "poi_type": "Shopping & Retail",
      "poi_address": "1070 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16448800570585714060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ronetco-supermarkets-inc",
      "poi_latitude": "40.8781916",
      "poi_longitude": "-74.647454",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-927-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJud8-ay6ew4kRjA0BL_jgReQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4b210336-1a7b-4449-9367-caa3a499376c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1103 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-14e3-7778-96d6-1b71bb32261f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-14e3-7778-96d6-1b71bb32261f",
        "storage_key": "property/6767906449166337/019d0269-14e3-7778-96d6-1b71bb32261f.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/ledgewood-nj-pharmacies/1103-route-46-ledgewood-nj-07852/storeid=1780?WT.mc_id=LS_GOOGLE_RX_1780",
      "poi_directions_map_url": "https://maps.google.com/?cid=18263884890884987797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.8799849",
      "poi_longitude": "-74.6436114",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-927-4662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-78cf-718b-880f-1296df9fcf18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-78cf-718b-880f-1296df9fcf18",
        "storage_key": "property/6767906449166337/019d0269-78cf-718b-880f-1296df9fcf18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ89DHXCyew4kRldvSw4padv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ef342e3b-65db-4a85-8d5f-f17e13fb19ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1131 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-1627-77af-9853-bf3775cc6ceb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-1627-77af-9853-bf3775cc6ceb",
        "storage_key": "property/6767906449166337/019d0269-1627-77af-9853-bf3775cc6ceb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1131+us+highway+46-ledgewood-nj-07852/id=9934",
      "poi_directions_map_url": "https://maps.google.com/?cid=4337978440462028774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.8796256",
      "poi_longitude": "-74.6498197",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-584-7855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkd1Uhi-ew4kR5s8Kc2iYMzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_21459976-5ed7-4ada-a605-b9ea5e1708fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "281 NJ-10, Succasunna, NJ 07876, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-15ad-7622-8b1a-faf43a6b73c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-15ad-7622-8b1a-faf43a6b73c9",
        "storage_key": "property/6767906449166337/019d0269-15ad-7622-8b1a-faf43a6b73c9.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Roxbury/NJ/Succasunna/07876/909?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8799334904844569723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "40.8681367",
      "poi_longitude": "-74.6490093",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-927-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7880-7129-acf2-59a0748acae5",
        "storage_key": "property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI7a5yjeew4kRe8z0nnmEHXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b213c5ab-a414-4760-8254-b0d326087df2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Marshalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "461 Route 10 East, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_long_description": "Retail chain offering brand-name clothing, accessories, shoes & housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-1c34-77ed-892c-285b1f3f78ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-1c34-77ed-892c-285b1f3f78ee",
        "storage_key": "property/6767906449166337/019d0269-1c34-77ed-892c-285b1f3f78ee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marshalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12109955208792723223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshalls",
      "poi_latitude": "40.8731394",
      "poi_longitude": "-74.6523409",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-927-2501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7880-7129-acf2-59a0748acae5",
        "storage_key": "property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ46RvQDCew4kRF0_74Rk0D6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_65272dcd-7366-4b9c-bdcb-23cd83ba4773",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "461 NJ-10 B400, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-1d49-72a4-83ad-96b91f307862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-1d49-72a4-83ad-96b91f307862",
        "storage_key": "property/6767906449166337/019d0269-1d49-72a4-83ad-96b91f307862.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.ulta.com/stores/ledgewood-nj-1537",
      "poi_directions_map_url": "https://maps.google.com/?cid=14472155691627727097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "40.87525979999999",
      "poi_longitude": "-74.6507427",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 862-259-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWDnxqCfw4kR-Uievexs18g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_e2c467d7-0c42-4037-a0c0-c51f6b6078db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Five Below",
      "poi_type": "Shopping & Retail",
      "poi_address": "461 NJ-10 Suite B500, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_long_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-1e82-77e4-8877-d3c7f9f86776.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-1e82-77e4-8877-d3c7f9f86776",
        "storage_key": "property/6767906449166337/019d0269-1e82-77e4-8877-d3c7f9f86776.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.fivebelow.com/nj/ledgewood/461-nj-10?utm_source=gmb&utm_medium=yext&y_source=1_MjAzMjEwNTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12100244102207034586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-below",
      "poi_latitude": "40.8752738",
      "poi_longitude": "-74.6507191",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-381-0313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7880-7129-acf2-59a0748acae5",
        "storage_key": "property/6767906449166337/019d0269-7880-7129-acf2-59a0748acae5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-3D47O6fw4kR2tSQr-az7Kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_52f7dc7f-61ed-410a-b566-5c946e899672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Jefferson Elementary School",
      "poi_type": "Education",
      "poi_address": "35 Corn Hollow Rd, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.roxbury.org/Domain/12",
      "poi_directions_map_url": "https://maps.google.com/?cid=8536712800075545974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-elementary-school",
      "poi_latitude": "40.8574194",
      "poi_longitude": "-74.6632432",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-584-8955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN76ZFF2ew4kRdn0I7g9_eHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_8a86afa9-2009-4870-91df-5399791f57d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Franklin Elementary School",
      "poi_type": "Education",
      "poi_address": "8 Meeker St, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.roxbury.org/Domain/11",
      "poi_directions_map_url": "https://maps.google.com/?cid=1530844997646198372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "franklin-elementary-school",
      "poi_latitude": "40.8703441",
      "poi_longitude": "-74.6333202",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-584-5549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNUWoUMmfw4kRZKbiImqnPhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_87a3bdd1-aa29-40ac-b947-25bfa547155f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Kennedy Elementary School",
      "poi_type": "Education",
      "poi_address": "20 Pleasant Hill Rd, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-1e82-77e4-8877-d7a381d5f3e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-1e82-77e4-8877-d7a381d5f3e8",
        "storage_key": "property/6767906449166337/019d0269-1e82-77e4-8877-d7a381d5f3e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roxbury.org/Domain/13",
      "poi_directions_map_url": "https://maps.google.com/?cid=16964155511807002010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennedy-elementary-school",
      "poi_latitude": "40.8456268",
      "poi_longitude": "-74.656784",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-584-3938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkd4Fn_aew4kRmsW9247JbOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e1445655-4e89-407d-bd92-50cec6a39f7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Lincoln Roosevelt School",
      "poi_type": "Education",
      "poi_address": "34 N Hillside Ave, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-230e-7544-9736-a9c2997637b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-230e-7544-9736-a9c2997637b3",
        "storage_key": "property/6767906449166337/019d0269-230e-7544-9736-a9c2997637b3.webp",
        "width": 1280,
        "height": 631
      },
      "poi_business_url": "https://www.roxbury.org/domain/10",
      "poi_directions_map_url": "https://maps.google.com/?cid=6314160114041000508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-roosevelt-school",
      "poi_latitude": "40.8723826",
      "poi_longitude": "-74.6367791",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-584-4331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ337t9syfw4kRPJJafCtnoFc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_542f4ab8-34d4-4926-9123-5863e5413731",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Eisenhower Middle School",
      "poi_type": "Education",
      "poi_address": "47 Eyland Ave, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.roxbury.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12899597240871716467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eisenhower-middle-school",
      "poi_latitude": "40.8608627",
      "poi_longitude": "-74.63613889999999",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-584-2973",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOaMM87Ofw4kRc4bEd1iTBLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_b0b2a404-a511-4049-a07a-3b15bdac79b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Roxbury High School",
      "poi_type": "Education",
      "poi_address": "1 Bryant Dr, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.roxbury.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13480082341783501552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roxbury-high-school",
      "poi_latitude": "40.8619227",
      "poi_longitude": "-74.6407752",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-584-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR36uTEuew4kR8HoFJXjfErs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_bdc70446-2eb7-4e58-9c83-f0022020b46c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "American Christian School - South Campus",
      "poi_type": "Education",
      "poi_address": "126 S Hillside Ave, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-23ec-726c-867b-a3a196a6b4cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-23ec-726c-867b-a3a196a6b4cc",
        "storage_key": "property/6767906449166337/019d0269-23ec-726c-867b-a3a196a6b4cc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.americanchristianschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8123011532769300146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "american-christian-school---south-campus",
      "poi_latitude": "40.8577738",
      "poi_longitude": "-74.6597649",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 973-584-6616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRQ23wlyew4kRso4dlfO7unA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6f14e875-4e50-45cb-8b7c-a58934188b1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "St Therese School",
      "poi_type": "Education",
      "poi_address": "135 Main St, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-2471-7560-9194-0a7ad7d53049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2471-7560-9194-0a7ad7d53049",
        "storage_key": "property/6767906449166337/019d0269-2471-7560-9194-0a7ad7d53049.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "http://sts.stthereseroxbury.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1063936220951882353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-therese-school",
      "poi_latitude": "40.873292",
      "poi_longitude": "-74.642314",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-584-0812",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq1lqwzOew4kRcSqCIVvcww4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_5ca5d437-7ea0-4f97-aceb-1e19717ff3c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Nixon Elementary School",
      "poi_type": "Education",
      "poi_address": "275 Mt Arlington Blvd, Landing, NJ 07850, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.roxbury.org/domain/14",
      "poi_directions_map_url": "https://maps.google.com/?cid=8855021967036800516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nixon-elementary-school",
      "poi_latitude": "40.9166841",
      "poi_longitude": "-74.65293390000001",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-398-2564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-Xq75bp1w4kRBF6CJ5Bb43o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7689036d-90fd-412d-a0ca-80764178016b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "County College of Morris",
      "poi_type": "Education",
      "poi_address": "214 Center Grove Rd, Randolph, NJ 07869, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-2545-772d-85d9-ddb5364812ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2545-772d-85d9-ddb5364812ec",
        "storage_key": "property/6767906449166337/019d0269-2545-772d-85d9-ddb5364812ec.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.ccm.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12455618561383653046&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "county-college-of-morris",
      "poi_latitude": "40.85817369999999",
      "poi_longitude": "-74.5814491",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 973-328-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJQff_xegw4kRtt4IwRY_26w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_be263b8d-fdd1-48ac-9cb8-94bac4c18548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Circle Bowl & Entertainment",
      "poi_type": "Entertainment",
      "poi_address": "1107 US-46 W, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Family-friendly bowling alley featuring laser tag, an arcade and a restaurant with beer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-292e-740b-8f97-d855f4757e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-292e-740b-8f97-d855f4757e93",
        "storage_key": "property/6767906449166337/019d0269-292e-740b-8f97-d855f4757e93.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "http://circlebowlnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819472900025942252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-bowl--entertainment",
      "poi_latitude": "40.88000419999999",
      "poi_longitude": "-74.64559609999999",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 973-584-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPc6IfC6ew4kR7AAPCsXrwlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_072cc888-d5a0-4ba3-b3d1-6a282226596b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "The Growing Stage - The Children's Theatre of New Jersey",
      "poi_type": "Entertainment",
      "poi_address": "7 Ledgewood Ave, Netcong, NJ 07857, USA",
      "poi_short_description": "Family-friendly theatre presenting kid-centered musicals as well as classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-29ed-76eb-8a0c-3f8faf31ac01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-29ed-76eb-8a0c-3f8faf31ac01",
        "storage_key": "property/6767906449166337/019d0269-29ed-76eb-8a0c-3f8faf31ac01.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.growingstage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9391098215241372210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-growing-stage---the-childrens-theatre-of-new-jersey",
      "poi_latitude": "40.900534",
      "poi_longitude": "-74.7042706",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 973-347-4946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3f5t4Rt2w4kRMlJEEhLiU4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_6b934eda-da7d-48cb-9893-2319cf3894b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Lake Hopatcong Historical Museum",
      "poi_type": "Entertainment",
      "poi_address": "State Park, Landing, NJ 07850, USA",
      "poi_short_description": "Located in a former lock tender's house, this museum focuses on Lake Hopatcong's past as a resort.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-2b9a-73de-83ad-af120b07c97d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2b9a-73de-83ad-af120b07c97d",
        "storage_key": "property/6767906449166337/019d0269-2b9a-73de-83ad-af120b07c97d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lakehopatconghistory.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17050225188643258721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hopatcong-historical-museum",
      "poi_latitude": "40.9165832",
      "poi_longitude": "-74.6650379",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-398-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f2b-74cf-b61f-3ffa8894fbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f2b-74cf-b61f-3ffa8894fbd0",
        "storage_key": "property/6767906449166337/019d0269-7f2b-74cf-b61f-3ffa8894fbd0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3mltEl0w4kRYcF_HXmRnuw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2434fec6-cd93-4df8-b6dc-0de313adb23a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "AMC Rockaway 16",
      "poi_type": "Entertainment",
      "poi_address": "363 Mt Hope Ave, Rockaway Township, NJ 07866, USA",
      "poi_short_description": "Movie theater chain in Rockaway Townsquare offering IMAX, Dolby Cinema, and comfortable seating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-2be2-72aa-bdf5-77394060c658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-2be2-72aa-bdf5-77394060c658",
        "storage_key": "property/6767906449166337/019d0269-2be2-72aa-bdf5-77394060c658.webp",
        "width": 1280,
        "height": 741
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/rockaway/amc-rockaway-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16711794955679547328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-rockaway-16",
      "poi_latitude": "40.9097033",
      "poi_longitude": "-74.55804049999999",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-328-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f2e-752e-ad3b-84088da2d8b8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f2e-752e-ad3b-84088da2d8b8",
        "storage_key": "property/6767906449166337/019d0269-7f2e-752e-ad3b-84088da2d8b8.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzQUk7ELw4kRwL9xJPg47Oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a9c85e2d-7ba8-44f6-a834-e39140632431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Waterloo Village Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "526 Waterloo Rd, Stanhope, NJ 07874, USA",
      "poi_short_description": "Museum, event space & park in a restored 19th-century town with historic buildings & canal exhibits.",
      "poi_long_description": "Museum, event space & park in a restored 19th-century town with historic buildings & canal exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-310c-7157-b9f0-9d612c26fb66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-310c-7157-b9f0-9d612c26fb66",
        "storage_key": "property/6767906449166337/019d0269-310c-7157-b9f0-9d612c26fb66.webp",
        "width": 699,
        "height": 392
      },
      "poi_business_url": "https://nj.gov/dep/parksandforests/historic/waterloovillage.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2818008092239072147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "waterloo-village-historic-site",
      "poi_latitude": "40.9162772",
      "poi_longitude": "-74.75964379999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-347-1835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIXvXcsJ3w4kRkwsW8G2TGyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_22664e8d-2523-4905-9fb4-a97ce5a6fa34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Wild West City",
      "poi_type": "Entertainment",
      "poi_address": "50 Lackawanna Dr, Stanhope, NJ 07874, USA",
      "poi_short_description": "Old West theme park offering pony rides & a petting zoo, plus a train, stagecoach rides & mini-golf.",
      "poi_long_description": "Old West theme park offering pony rides & a petting zoo, plus a train, stagecoach rides & mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-3307-734c-9c01-4967967c2b8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3307-734c-9c01-4967967c2b8a",
        "storage_key": "property/6767906449166337/019d0269-3307-734c-9c01-4967967c2b8a.webp",
        "width": 1011,
        "height": 569
      },
      "poi_business_url": "http://www.wildwestcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4924535839680971867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wild-west-city",
      "poi_latitude": "40.9348314",
      "poi_longitude": "-74.7105851",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 973-347-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzbGybvV2w4kRW0TdP0F3V0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_eb299fef-61f2-49ea-ae90-8e624f5a8193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Pax Amicus Castle Theatre",
      "poi_type": "Entertainment",
      "poi_address": "23 Lake Shore Rd, Budd Lake, NJ 07828, USA",
      "poi_short_description": "Casual performing arts theater presenting a schedule of live productions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-32e2-756f-929d-95dba8dbccbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-32e2-756f-929d-95dba8dbccbc",
        "storage_key": "property/6767906449166337/019d0269-32e2-756f-929d-95dba8dbccbc.webp",
        "width": 1280,
        "height": 824
      },
      "poi_business_url": "http://www.paxamicus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160289602823068957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pax-amicus-castle-theatre",
      "poi_latitude": "40.8661953",
      "poi_longitude": "-74.7528203",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-691-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQ1_yB6dw4kRHR2hW6aa2ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_4f2e8c17-c58d-4887-aa25-7c0aacc331fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Morris Museum",
      "poi_type": "Entertainment",
      "poi_address": "6 Normandy Heights Rd, Morristown, NJ 07960, USA",
      "poi_short_description": "Local museum on the outskirts of Morristown hosts cultural exhibits & theatrical performances.",
      "poi_long_description": "Local museum on the outskirts of Morristown hosts cultural exhibits & theatrical performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-32e9-77f6-82f4-1700f725f8da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-32e9-77f6-82f4-1700f725f8da",
        "storage_key": "property/6767906449166337/019d0269-32e9-77f6-82f4-1700f725f8da.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.morrismuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2374821970878289990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morris-museum",
      "poi_latitude": "40.7960409",
      "poi_longitude": "-74.44829639999999",
      "poi_miles_from_property": "15.9",
      "poi_walking_minutes": "5 hours 51 mins",
      "poi_biking_minutes": "1 hour 42 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 973-971-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f2b-74cf-b61f-3ffa8894fbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f2b-74cf-b61f-3ffa8894fbd0",
        "storage_key": "property/6767906449166337/019d0269-7f2b-74cf-b61f-3ffa8894fbd0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-_lhZGGmw4kRRlj-CgAQ9SA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f739eccd-95b1-4e71-8554-4e98915df0d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Mayo Performing Arts Center (MPAC)",
      "poi_type": "Entertainment",
      "poi_address": "100 South St, Morristown, NJ 07960, USA",
      "poi_short_description": "Nonprofit community theater hosting readings, plays, performances & live concerts since 1937.",
      "poi_long_description": "Nonprofit community theater hosting readings, plays, performances & live concerts since 1937.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-375b-771f-8bf3-ad2545bbe5ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-375b-771f-8bf3-ad2545bbe5ab",
        "storage_key": "property/6767906449166337/019d0269-375b-771f-8bf3-ad2545bbe5ab.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.mayoarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11240132265015052930&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mayo-performing-arts-center-mpac",
      "poi_latitude": "40.7943969",
      "poi_longitude": "-74.4778986",
      "poi_miles_from_property": "14.5",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 973-539-8008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzz0nzKKmw4kRggqhBL74_Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_5abe7783-eb97-4b5a-b5a7-2614bc961b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Sterling Hill Mining Museum",
      "poi_type": "Entertainment",
      "poi_address": "30 Plant St, Ogdensburg, NJ 07439, USA",
      "poi_short_description": "Underground tours of an old mine with fluorescent minerals, plus displays of machinery & a museum.",
      "poi_long_description": "Underground tours of an old mine with fluorescent minerals, plus displays of machinery & a museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-396a-76d0-9519-ca2d2aca43ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-396a-76d0-9519-ca2d2aca43ce",
        "storage_key": "property/6767906449166337/019d0269-396a-76d0-9519-ca2d2aca43ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sterlinghillminingmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=628388684455963715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-hill-mining-museum",
      "poi_latitude": "41.0835394",
      "poi_longitude": "-74.6041832",
      "poi_miles_from_property": "16.9",
      "poi_walking_minutes": "6 hours 12 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 973-209-7212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f2b-74cf-b61f-3ffa8894fbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f2b-74cf-b61f-3ffa8894fbd0",
        "storage_key": "property/6767906449166337/019d0269-7f2b-74cf-b61f-3ffa8894fbd0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTwg_tlsw4kRQ2zf3S18uAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_52ef62f1-b632-436e-88f2-5af3b217b2f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Saint Clare's Dover Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "400 W Blackwell St, Dover, NJ 07801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-3926-767b-ae1c-4b2455e20f64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3926-767b-ae1c-4b2455e20f64",
        "storage_key": "property/6767906449166337/019d0269-3926-767b-ae1c-4b2455e20f64.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://saintclares.com/locations/saint-clares-dover-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7311546857722953505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-clares-dover-hospital",
      "poi_latitude": "40.884662",
      "poi_longitude": "-74.575925",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 973-989-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f31-7727-b040-c3175698e3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f31-7727-b040-c3175698e3a5",
        "storage_key": "property/6767906449166337/019d0269-7f31-7727-b040-c3175698e3a5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnZnKgaQKw4kRIT8z_SDVd2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_347fb12d-11ed-486e-aa92-fd6b25212fb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Morristown Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Madison Ave, Morristown, NJ 07960, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-3a2c-704d-888b-0690bb30db29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3a2c-704d-888b-0690bb30db29",
        "storage_key": "property/6767906449166337/019d0269-3a2c-704d-888b-0690bb30db29.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/morristown-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6835593742196230722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morristown-medical-center",
      "poi_latitude": "40.7894519",
      "poi_longitude": "-74.4658709",
      "poi_miles_from_property": "15.4",
      "poi_walking_minutes": "5 hours 38 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 973-971-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f31-7727-b040-c3175698e3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f31-7727-b040-c3175698e3a5",
        "storage_key": "property/6767906449166337/019d0269-7f31-7727-b040-c3175698e3a5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31s7Ppumw4kRQkp9wEro3F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_dfc3a125-3b87-48ac-9f7f-a9c969eb1970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Atlantic Health Urgent Care at Ledgewood",
      "poi_type": "Health and Wellness",
      "poi_address": "501 NJ-10, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-3ee7-7376-b41c-5e96d834fe99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-3ee7-7376-b41c-5e96d834fe99",
        "storage_key": "property/6767906449166337/019d0269-3ee7-7376-b41c-5e96d834fe99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/urgent-care-ledgewood",
      "poi_directions_map_url": "https://maps.google.com/?cid=2295486677193665147&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-health-urgent-care-at-ledgewood",
      "poi_latitude": "40.8761818",
      "poi_longitude": "-74.6507656",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-584-6751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-UVLXdCfw4kReyrFjPg02x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_821d8a87-13da-4619-b00d-359d154fcad3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "1103 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-409c-70bb-82a5-b69653dfcac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-409c-70bb-82a5-b69653dfcac0",
        "storage_key": "property/6767906449166337/019d0269-409c-70bb-82a5-b69653dfcac0.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.cvs.com/store-locator/ledgewood-nj-pharmacies/1103-route-46-ledgewood-nj-07852/storeid=1780?WT.mc_id=LS_GOOGLE_FS_1780",
      "poi_directions_map_url": "https://maps.google.com/?cid=16923360432237024087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.87992149999999",
      "poi_longitude": "-74.6436026",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-927-4662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfhlfC6ew4kRV5NjOaba2-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_4650314a-18be-47f5-9f2e-7cdcb0df40f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "461 NJ-10 Ste A100, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-40bd-731f-9d23-383960f675a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-40bd-731f-9d23-383960f675a3",
        "storage_key": "property/6767906449166337/019d0269-40bd-731f-9d23-383960f675a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/3912-ledgewood-nj/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=402478443492830165&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "40.873571",
      "poi_longitude": "-74.6523206",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 973-598-4087",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-78cf-718b-880f-1296df9fcf18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-78cf-718b-880f-1296df9fcf18",
        "storage_key": "property/6767906449166337/019d0269-78cf-718b-880f-1296df9fcf18.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixFUQDCew4kR1WskDgPklQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_31bcbb72-f0dd-4920-98c5-7b1ce26ab977",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "275 NJ-10 E, Succasunna, NJ 07876, USA",
      "poi_short_description": "Welcoming fitness center offering cardio and weight machines.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-406c-766e-b393-c43ec2e55551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-406c-766e-b393-c43ec2e55551",
        "storage_key": "property/6767906449166337/019d0269-406c-766e-b393-c43ec2e55551.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/succasunna-nj?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13394448908634214404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.8694431",
      "poi_longitude": "-74.6476387",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 862-244-4327",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJByi2kDaew4kRBNBCyVCk4rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5061179c-4af9-4534-80fb-5bea606889c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Driven Fitness & Performance - Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "19 NJ-10 Unit 4, Succasunna, NJ 07876, USA",
      "poi_short_description": "Group, individual training for a gym with a family vibe, which focuses on endurance and agility.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-46f3-734a-850e-acb03fa06ddd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-46f3-734a-850e-acb03fa06ddd",
        "storage_key": "property/6767906449166337/019d0269-46f3-734a-850e-acb03fa06ddd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homeofthedriven.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10301360419539466638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "driven-fitness--performance---gym",
      "poi_latitude": "40.8605779",
      "poi_longitude": "-74.6294762",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 973-784-8140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzeO2jsqfw4kRjjnr_bjI9Y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53de0ea2-4b79-4801-b768-e2ad4e94750e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "274 NJ-10, Succasunna, NJ 07876, USA",
      "poi_short_description": "Health club offering classes that combine cardio and strength-training exercises.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-4b16-74cd-8c1d-1322c56a3699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4b16-74cd-8c1d-1322c56a3699",
        "storage_key": "property/6767906449166337/019d0269-4b16-74cd-8c1d-1322c56a3699.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/succasunna-new-jersey-0992?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=1350712463638764735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "40.8726273",
      "poi_longitude": "-74.6448466",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-510-2440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-Umw_qfw4kRv5zhTNSxvhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_25c23fea-3f4c-4d87-8d75-1171f6305dfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Yoga West Holistic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "86 Main St, Succasunna, NJ 07876, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16782937979331420468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yoga-west-holistic-center",
      "poi_latitude": "40.8672201",
      "poi_longitude": "-74.637146",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 973-584-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f35-7316-88a4-3be5d15d3592",
        "storage_key": "property/6767906449166337/019d0269-7f35-7316-88a4-3be5d15d3592.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvwEe9cqfw4kRNCF2ISz56Og",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_319d31e9-9e29-45a9-af4f-9604c0058698",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Horseshoe Lake Recreation Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "72 Eyland Ave, Succasunna, NJ 07876, USA",
      "poi_short_description": "Recreation complex featuring a lake with fishing & swimming, a playground, sports facilities & more.",
      "poi_long_description": "Recreation complex featuring a lake with fishing & swimming, a playground, sports facilities & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-4a12-777c-bfaf-4e3e65677b11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4a12-777c-bfaf-4e3e65677b11",
        "storage_key": "property/6767906449166337/019d0269-4a12-777c-bfaf-4e3e65677b11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roxburynj.us/341/Township-Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16944063530552067404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "horseshoe-lake-recreation-complex",
      "poi_latitude": "40.8564895",
      "poi_longitude": "-74.6360285",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 973-448-2015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG10Evq2fw4kRTAU17gFoJes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4e08f568-610d-4e18-9ab3-cd0ed6489671",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Morris Canal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1800 US-46, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Park of wooded land with a lake, hiking trails and an old Morris Canal.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-4ae8-77db-a115-32eb6b22ce88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4ae8-77db-a115-32eb6b22ce88",
        "storage_key": "property/6767906449166337/019d0269-4ae8-77db-a115-32eb6b22ce88.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://hikeroxbury.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1728664403999027187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morris-canal-park",
      "poi_latitude": "40.8855808",
      "poi_longitude": "-74.66492769999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcX9jJh-ew4kR82852B1z_Rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_83e196aa-15e4-4293-8788-ce6a537a3046",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Riggs Canal Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "197 E Main St, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-4ff9-757f-b992-5ff703d17bcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-4ff9-757f-b992-5ff703d17bcf",
        "storage_key": "property/6767906449166337/019d0269-4ff9-757f-b992-5ff703d17bcf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6053269566217176299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riggs-canal-park",
      "poi_latitude": "40.8769",
      "poi_longitude": "-74.64928990000001",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxbsclxWfw4kR68QOUJmIAVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b49388ff-62bc-40e0-828f-42bfc2ff972c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Ledgewood Historic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "211 E Main St, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-525d-74ec-a587-77f9b1525476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-525d-74ec-a587-77f9b1525476",
        "storage_key": "property/6767906449166337/019d0269-525d-74ec-a587-77f9b1525476.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roxburynewjersey.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7376612497391877546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ledgewood-historic-park",
      "poi_latitude": "40.8784306",
      "poi_longitude": "-74.6515671",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 973-927-7603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPauyIzCew4kRqv2_wPv9XmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_64657203-c710-4a97-84ae-836daedf4f66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Emmans Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "75 Emmans Rd, Ledgewood, NJ 07852, USA",
      "poi_short_description": "Outdoor park with soccer fields is a dog-friendly destination.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-52a3-747f-a3f8-1ba51b694a52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-52a3-747f-a3f8-1ba51b694a52",
        "storage_key": "property/6767906449166337/019d0269-52a3-747f-a3f8-1ba51b694a52.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.roxburynj.us/341/Township-Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=251566744540378808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emmans-park",
      "poi_latitude": "40.8728231",
      "poi_longitude": "-74.6605891",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxf7evT6ew4kRuHahDZ--fQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f2e2a890-8186-4787-adfa-fafb0512854c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Nalron Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "67 Emmans Rd, Ledgewood, NJ 07852, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-552d-75cd-a72e-ca3d47fb54eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-552d-75cd-a72e-ca3d47fb54eb",
        "storage_key": "property/6767906449166337/019d0269-552d-75cd-a72e-ca3d47fb54eb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.roxburynj.us/341/Township-Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=1865945942714496465&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nalron-park",
      "poi_latitude": "40.8761427",
      "poi_longitude": "-74.6587642",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJN0xG2D-ew4kR0TWU3fIr5Rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_afc3ff83-256a-4068-b64f-b5030f8aa9a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Black River Park Parking Lot",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Main St, Succasunna, NJ 07876, USA",
      "poi_short_description": "Relaxed park surrounding a lake, featuring hiking trails, fishing spots and benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-5809-7789-b697-ccbe6907f25c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5809-7789-b697-ccbe6907f25c",
        "storage_key": "property/6767906449166337/019d0269-5809-7789-b697-ccbe6907f25c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.roxburynj.us/341/Township-Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=7887357161656330670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-river-park-parking-lot",
      "poi_latitude": "40.8622306",
      "poi_longitude": "-74.6282058",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQBZKrifw4kRrqkorYyFdW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_423f2b84-e4a4-44ff-9e60-47a545bc513f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kiwanis Park, 9 Makin Ln, Succasunna, NJ 07876, USA",
      "poi_short_description": "Sports and games facility featuring tennis courts and baseball fields, plus a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-5ce5-7768-9a43-28edeaa157c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5ce5-7768-9a43-28edeaa157c5",
        "storage_key": "property/6767906449166337/019d0269-5ce5-7768-9a43-28edeaa157c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.roxburynj.us/341/Township-Parks-Playgrounds",
      "poi_directions_map_url": "https://maps.google.com/?cid=16606092578714689450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "40.8452335",
      "poi_longitude": "-74.6691357",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 973-448-2015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8WqB4yew4kRqh-KrTexdOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_74378b8c-9053-46c7-a69c-76b2b6826631",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Hopatcong State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "260 Lakeside Blvd, Landing, NJ 07850, USA",
      "poi_short_description": "Park with aquatic recreation options, including boating, swimming & fishing, plus an athletic field.",
      "poi_long_description": "Park with aquatic recreation options, including boating, swimming & fishing, plus an athletic field.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-5c8e-7552-8d03-38d24f80256f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5c8e-7552-8d03-38d24f80256f",
        "storage_key": "property/6767906449166337/019d0269-5c8e-7552-8d03-38d24f80256f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nj.gov/dep/parksandforests/parks/hopatcongstatepark.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11304170543698965182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hopatcong-state-park",
      "poi_latitude": "40.9159878",
      "poi_longitude": "-74.66423379999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 973-398-7010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-838b-76c4-a9ca-47cf6b286ec4",
        "storage_key": "property/6767906449166337/019d0269-838b-76c4-a9ca-47cf6b286ec4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxSgFh8B1w4kRvnKcqTd74Jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a11a54cd-c693-4e73-a113-37d16a1710cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Netcong",
      "poi_type": "Transportation & Transit",
      "poi_address": "Maint St & Rt 46, Netcong, NJ 07857, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-5c64-7715-b814-39f22f898d08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-5c64-7715-b814-39f22f898d08",
        "storage_key": "property/6767906449166337/019d0269-5c64-7715-b814-39f22f898d08.webp",
        "width": 1024,
        "height": 697
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=101",
      "poi_directions_map_url": "https://maps.google.com/?cid=4390239815921802326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "netcong",
      "poi_latitude": "40.8975045",
      "poi_longitude": "-74.7073052",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 973-275-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8380-721c-a231-5f59c7f3effa",
        "storage_key": "property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTnv_x52w4kRVpzLItpD7Tw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_48ad955d-8c97-4044-8503-9c8b1ae64d70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7 Howard Blvd, Mt Arlington, NJ 07856, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10252283295645513350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park--ride",
      "poi_latitude": "40.8971193",
      "poi_longitude": "-74.6330071",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8384-76cb-bbec-c16c932af61b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8384-76cb-bbec-c16c932af61b",
        "storage_key": "property/6767906449166337/019d0269-8384-76cb-bbec-c16c932af61b.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJg6bNy3Z1w4kRhjafpVZtR44",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_0e1b2209-4a1b-4bdb-9459-9e18ca6db66a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Lake Hopatcong",
      "poi_type": "Transportation & Transit",
      "poi_address": "Roxbury Township, NJ 07850, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-6034-7348-8d4e-f6b2363c1d1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6034-7348-8d4e-f6b2363c1d1b",
        "storage_key": "property/6767906449166337/019d0269-6034-7348-8d4e-f6b2363c1d1b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14910139811642599003&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hopatcong",
      "poi_latitude": "40.9040904",
      "poi_longitude": "-74.6655462",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8380-721c-a231-5f59c7f3effa",
        "storage_key": "property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xdXfet1w4kRW-ZdUCl1684",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e5782d11-8c19-470e-9437-1be11efc478e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Mount Olive",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mt Olive, NJ 07828, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-628b-7483-94fb-dec51060830c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-628b-7483-94fb-dec51060830c",
        "storage_key": "property/6767906449166337/019d0269-628b-7483-94fb-dec51060830c.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7681081535091119717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-olive",
      "poi_latitude": "40.9074311",
      "poi_longitude": "-74.7307773",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8380-721c-a231-5f59c7f3effa",
        "storage_key": "property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJcQQ9nS12w4kRZRbrxfWumGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_eb5e6682-ae21-46b8-bcff-b7eebb21a47d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Dover",
      "poi_type": "Transportation & Transit",
      "poi_address": "E Dickerson St, Dover, NJ 07801, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-61f6-70e6-93de-63453859bccb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-61f6-70e6-93de-63453859bccb",
        "storage_key": "property/6767906449166337/019d0269-61f6-70e6-93de-63453859bccb.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=35",
      "poi_directions_map_url": "https://maps.google.com/?cid=17774155388190135702&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dover",
      "poi_latitude": "40.8836346",
      "poi_longitude": "-74.5555236",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8380-721c-a231-5f59c7f3effa",
        "storage_key": "property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJMUfLcIUKw4kRlhWrbyd8qvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_fab9ea6c-464c-4032-ad64-a7ce716a28a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Mount Arlington",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mt Arlington, NJ 07847, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-6322-75ba-8681-7df665ce5bd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6322-75ba-8681-7df665ce5bd2",
        "storage_key": "property/6767906449166337/019d0269-6322-75ba-8681-7df665ce5bd2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=39472",
      "poi_directions_map_url": "https://maps.google.com/?cid=3607091910923348128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mount-arlington",
      "poi_latitude": "40.8965036",
      "poi_longitude": "-74.6327757",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8380-721c-a231-5f59c7f3effa",
        "storage_key": "property/6767906449166337/019d0269-8380-721c-a231-5f59c7f3effa.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJkw6nwnB1w4kRoGjFVvv2DjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_cbef49b5-a759-4d3a-bf78-fd2f494bf73a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Newark Liberty International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark International Airport St, Newark, NJ 07114, USA",
      "poi_short_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_long_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-658a-77bb-ade2-b7fd910f8dee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-658a-77bb-ade2-b7fd910f8dee",
        "storage_key": "property/6767906449166337/019d0269-658a-77bb-ade2-b7fd910f8dee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newarkairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12966905903765254790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-liberty-international-airport",
      "poi_latitude": "40.6884837",
      "poi_longitude": "-74.17686359999999",
      "poi_miles_from_property": "39.2",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 31 mins",
      "poi_driving_minutes": "44 mins",
      "poi_business_phone": "+1 973-961-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8388-743d-9c91-e44d28ab49b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8388-743d-9c91-e44d28ab49b7",
        "storage_key": "property/6767906449166337/019d0269-8388-743d-9c91-e44d28ab49b7.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wzsxeFSwokRhvLXxTe087M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_9dc3ba0f-8635-4663-ade2-34217d6cb02e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Picatinny Arsenal",
      "poi_type": "Major Employers & Offices",
      "poi_address": "213 NJ-15, Wharton, NJ 07885, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-677b-738a-8b93-d36c92eedb38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-677b-738a-8b93-d36c92eedb38",
        "storage_key": "property/6767906449166337/019d0269-677b-738a-8b93-d36c92eedb38.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://home.army.mil/picatinny",
      "poi_directions_map_url": "https://maps.google.com/?cid=6390813921455506284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "picatinny-arsenal",
      "poi_latitude": "40.9170823",
      "poi_longitude": "-74.58051929999999",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8758-77a1-b6d9-5feaceac0028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8758-77a1-b6d9-5feaceac0028",
        "storage_key": "property/6767906449166337/019d0269-8758-77a1-b6d9-5feaceac0028.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSzGpX4Mw4kRbAP6zWa7sFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_54eedea5-f11d-4816-bcb0-60819e467511",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Atlantic Health System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "475 South St, Morristown, NJ 07960, USA",
      "poi_short_description": "Healthcare provider featuring multiple medical groups and hospitals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-68ab-779c-9fe8-5a1bc389184d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-68ab-779c-9fe8-5a1bc389184d",
        "storage_key": "property/6767906449166337/019d0269-68ab-779c-9fe8-5a1bc389184d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantichealth.org/?utm_source=google&utm_medium=business-listings&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1028027449250891325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlantic-health-system",
      "poi_latitude": "40.7731783",
      "poi_longitude": "-74.469562",
      "poi_miles_from_property": "16.3",
      "poi_walking_minutes": "5 hours 57 mins",
      "poi_biking_minutes": "1 hour 35 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 800-247-9580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ07NwWZumw4kRPUbzs4RJRA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c1aed942-d6fb-484d-8007-3c93c6e3101b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Administration Records bldg.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10 Court St, Morristown, NJ 07960, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5535141245192980124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "administration-records-bldg",
      "poi_latitude": "40.7971813",
      "poi_longitude": "-74.4841148",
      "poi_miles_from_property": "14.2",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 30 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-8758-77a1-b6d9-5feaceac0028.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-8758-77a1-b6d9-5feaceac0028",
        "storage_key": "property/6767906449166337/019d0269-8758-77a1-b6d9-5feaceac0028.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwwWkELumw4kRnEZX1aLF0Ew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_dd498b81-b831-497a-917b-e5438fe6c86f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Novartis Pharmaceuticals Corp.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Health Plaza, East Hanover, NJ 07936, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-68ba-71a6-a552-2788b801a852.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-68ba-71a6-a552-2788b801a852",
        "storage_key": "property/6767906449166337/019d0269-68ba-71a6-a552-2788b801a852.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pharma.us.novartis.com/index.jsp?usertrack.filter_applied=true&NovaId=4029462146185769411",
      "poi_directions_map_url": "https://maps.google.com/?cid=7448447622001011844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "novartis-pharmaceuticals-corp",
      "poi_latitude": "40.80463",
      "poi_longitude": "-74.3860215",
      "poi_miles_from_property": "19.2",
      "poi_walking_minutes": "6 hours 59 mins",
      "poi_biking_minutes": "2 hours 13 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 862-778-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwfdsYuow4kRhCx5DaYzXmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_486c6421-6a2e-45a7-982e-e4adfcd37c5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "BASF Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Park Ave, Florham Park, NJ 07932, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-6b40-7747-9d96-e96095483272.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6b40-7747-9d96-e96095483272",
        "storage_key": "property/6767906449166337/019d0269-6b40-7747-9d96-e96095483272.webp",
        "width": 1280,
        "height": 907
      },
      "poi_business_url": "http://basf.com/us",
      "poi_directions_map_url": "https://maps.google.com/?cid=14818007841915472876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "basf-corporation",
      "poi_latitude": "40.7772866",
      "poi_longitude": "-74.4271761",
      "poi_miles_from_property": "17.8",
      "poi_walking_minutes": "6 hours 29 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 973-245-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpaDNb2BLDogR7AtTgJ8jpM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b3d149f7-99ce-4cb5-8d89-86a2841847b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Chilton Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "97 West Pkwy, Pompton Plains, NJ 07444, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-6d14-76cd-b625-75d3457a7824.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6d14-76cd-b625-75d3457a7824",
        "storage_key": "property/6767906449166337/019d0269-6d14-76cd-b625-75d3457a7824.webp",
        "width": 512,
        "height": 288
      },
      "poi_business_url": "https://www.atlantichealth.org/locations/chilton-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=5278185616076847461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilton-medical-center",
      "poi_latitude": "40.9584357",
      "poi_longitude": "-74.309764",
      "poi_miles_from_property": "25.2",
      "poi_walking_minutes": "9 hours 10 mins",
      "poi_biking_minutes": "2 hours 29 mins",
      "poi_driving_minutes": "34 mins",
      "poi_business_phone": "+1 973-831-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7f31-7727-b040-c3175698e3a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7f31-7727-b040-c3175698e3a5",
        "storage_key": "property/6767906449166337/019d0269-7f31-7727-b040-c3175698e3a5.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfMIQ1wDw4kRZTnWUNrhP0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bb725c65-6c20-46e0-93c1-f43fa4ddaa36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "poi_name": "Bayer Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Bayer Blvd, Whippany, NJ 07981, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-6ff6-7268-86f9-327811b9bda0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0269-6ff6-7268-86f9-327811b9bda0",
        "storage_key": "property/6767906449166337/019d0269-6ff6-7268-86f9-327811b9bda0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bayer.com/en/",
      "poi_directions_map_url": "https://maps.google.com/?cid=35563024910512207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayer-corporation",
      "poi_latitude": "40.8177598",
      "poi_longitude": "-74.4124873",
      "poi_miles_from_property": "17.7",
      "poi_walking_minutes": "6 hours 26 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 862-404-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0269-7888-7045-88b7-970e19f482f5",
        "storage_key": "property/6767906449166337/019d0269-7888-7045-88b7-970e19f482f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJddMT6tOnw4kRT_Dt-mFYfgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d68e48c35ee6995ad26164e6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fbde5c1a27e3ead21ee9fe3f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a005925a053b8deebc5ecedb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2d4b36b1cfd5952855781038",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3195af9503b4f692979f7ce2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3f4dc45d5da0fe7aeba92801",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_bdfd2728-04c2-49b2-b559-a6bd2b57cd23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "rating": "5.0",
      "name": "Eric B",
      "text": "My wife and I have lived at Parc at Roxbury for almost 4 years.  It is not only a great place to live, but the maintenance inside and outside the buildings is thorough, efficient, and timely.  I especially would like to compliment John and Anthony for the professional, friendly, and timely action that they have taken on all maintenance issues involving our apartment. The Residents of Parc at Roxbury and Ion Management are lucky to have this maintenance team serving us all.",
      "date": "2025-01-15",
      "title": "Great Service!"
    },
    {
      "id": "custom_9d963059-c3cf-4718-80e1-dcd4adafe151",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "rating": "5.0",
      "name": "Sydney B",
      "text": "Lived here for 1 year. Maintenance, staff, amenities, size, style, and comfort were all excellent. Very quiet neighborhood with quick access to walking trails. There is valet trash (they come to your door to take your garbage), parking for guests is free and plentiful, there are spaces throughout community for WFH and social events. There is a children’s playground and two dog runs. Overall great community.",
      "date": "2024-08-31",
      "title": "Great place to live!"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a739d3c2-ba53-4f2a-94f2-30029129596e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/019fa55a-1110-7563-85ed-39f63ec6d2be.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fa55a-1110-7563-85ed-39f63ec6d2be",
        "storage_key": "property/6767906449166337/019fa55a-1110-7563-85ed-39f63ec6d2be.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6318aaff71336513868d6436&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_b7e0cde16333e3a4b930dbe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429551",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_27f0362d6b67055f2a595a9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429552",
      "name": "Garage Parking",
      "description": "false",
      "amount": 150,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6eb869f8fcffc1c9c0eaa2ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429553",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_741ba09e2424c352313fd488",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429554",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_4aaf72e2bb9930bbcd21882b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429556",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 450,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_a0dca4307cb7a92c0a9f1fd7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429558",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_54c66a349a809125ee817e2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429559",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c77dc7a45240e6c2cf24eecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "429561",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_18859df68d968a0858628a9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "541021",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_586a0b25ca88801117136734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "541022",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cda639e873dbdc7fba5d1d46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "541023",
      "name": "Trash Service",
      "description": "false",
      "amount": 30,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_13344ff308672ca873b8120c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "543124",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_344e170dea6b05ccf0929981",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "543126",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ca0de95122b391590baaa636",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "543136",
      "name": "Pest Control",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_70a0e0de16c9512101ae585f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "835261",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Two Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_464edce55fa6bc6a6332f3a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "835266",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_3b990b326916747172094f8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "835268",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_dfd4875f782f5dc1b5f68a7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "835274",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 400,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_60988ce43f923c2ed98724c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "835276",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_50415e5077e9e66717dbde5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "867219",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_831ad4b386a56364ec310d9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "engrain",
      "external_id": "945449",
      "name": "Utility - Gas",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a31a8-6e40-725b-bc84-240cd2b0752c",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Parc at Roxbury property website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337"
    },
    {
      "lead_collector_id": "019c3043-8850-70eb-b081-daa7e9790cda",
      "lead_source": "FACEBOOK_ADS",
      "name": "parc-at-roxbury",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337"
    },
    {
      "lead_collector_id": "019c3043-88c6-75be-8dc2-a97b1b7564f6",
      "lead_source": "LANDING_PAGE",
      "name": "parc-at-roxbury",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-roxbury-township-nj-233",
      "search_query": "pet friendly apartments Roxbury Township NJ",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Roxbury Township, NJ",
      "h2_subtitle": "Discover pet-friendly living at Parc at Roxbury. Our community in Roxbury Township, NJ, offers a welcoming atmosphere for you and your furry friends.",
      "page_copy": "At Parc at Roxbury, we understand that pets are family too, which is why our vibrant community embraces a pet-friendly culture. Located in the heart of Roxbury Township, NJ, our stylish one and two-bedroom apartments offer the ideal backdrop for you and your furry companions. Surrounded by scenic walking trails, residents and their pets can enjoy leisurely strolls in a peaceful setting.\n\nOur community features a lively atmosphere with convenient amenities such as an Amazon Hub Locker and a state-of-the-art fitness center. Covered parking and EV charging stations add to the convenience of living here. Set in Morris County’s charming Ledgewood neighborhood, Parc at Roxbury provides the perfect home for both you and your pets. Experience modern living and discover why our pet-friendly apartments in Roxbury Township, NJ, are the perfect fit for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Roxbury Township, NJ",
      "seo_description": "Enjoy pet-friendly apartments at Parc at Roxbury in Roxbury Township, NJ. Experience comfort with modern amenities in a pet-welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-with-pool-morris-county-nj-303",
      "search_query": "apartments with pool in Morris County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Morris County, NJ",
      "h2_subtitle": "Find your ideal apartment with pool access in Morris County. Explore Parc at Roxbury's vibrant community and extensive amenities today.",
      "page_copy": "Dive into luxury living at Parc at Roxbury, nestled in the serene landscape of Morris County, NJ. Although our community does not feature a pool, it boasts a host of attractive amenities that make it a compelling choice for residents seeking quality living. Our spacious one and two-bedroom apartments are designed with modern conveniences, including Amazon Hub Lockers and EV charging stations, ensuring residents have everything they need at their fingertips.\n\nWhile enjoying life at Parc at Roxbury, residents can take advantage of nearby local pools and recreation centers within Morris County. Our prime location in Roxbury Township offers access to a thriving community with scenic trails perfect for leisurely walks. Choose Parc at Roxbury for a complete living experience, where comfort, style, and convenience come together harmoniously.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Morris County, NJ",
      "seo_description": "Explore Parc at Roxbury in Morris County, NJ. Enjoy modern amenities in a vibrant community without a pool but with extensive conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "fitness-center-apartments-near-ledgewood-nj-18",
      "search_query": "fitness center apartments near Ledgewood",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center Near Ledgewood",
      "h2_subtitle": "Experience top-notch living at Parc at Roxbury. Our apartments near Ledgewood offer an exceptional fitness center and modern living amenities.",
      "page_copy": "At Parc at Roxbury, staying active is made easy with our state-of-the-art fitness center just minutes from Ledgewood, NJ. Our community is perfect for fitness enthusiasts looking for a dynamic lifestyle in Morris County. Whether you're into cardio or weight training, our well-equipped fitness center caters to all your workout needs right at home.\n\nIn addition to our fitness center, Parc at Roxbury offers an array of modern amenities designed for comfort and convenience. From cable and satellite-ready apartments to Amazon Hub Lockers, residents enjoy unparalleled ease of living. Located in the vibrant Roxbury Township, you'll have access to scenic trails and a pet-friendly atmosphere. Live your best life while staying fit and active at this prime location near Ledgewood.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Near Ledgewood",
      "seo_description": "Discover Parc at Roxbury's fitness center apartments near Ledgewood. Enjoy modern living with top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "ev-charging-stations-apartments-07852-311",
      "search_query": "EV charging stations in apartments 07852",
      "category": "Amenity",
      "h1_title": "Apartments with EV Charging Stations 07852",
      "h2_subtitle": "Explore Parc at Roxbury's modern apartments with EV charging stations in the vibrant 07852 area. Discover convenient and sustainable living today.",
      "page_copy": "Located in the inviting Roxbury Township, NJ, within the 07852 zip code, Parc at Roxbury offers an exceptional living environment equipped with EV charging stations. Our community understands the importance of sustainable living and convenience. With electric vehicle charging readily available, residents can effortlessly keep their eco-friendly cars powered up.\n\nParc at Roxbury not only provides modern amenities such as spacious one and two-bedroom apartments and Amazon Hub Lockers but also fosters a vibrant, pet-friendly atmosphere surrounded by scenic walking trails. Our commitment to providing advanced facilities like EV charging stations is just one way we support a contemporary, hassle-free lifestyle. Discover the ease of living in a community designed with modern-day needs in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with EV Charging Stations 07852",
      "seo_description": "Find apartments with EV charging stations in 07852 at Parc at Roxbury. Enjoy convenient, sustainable living in a modern community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "dog-park-apartments-roxbury-township-316",
      "search_query": "dog park apartments Roxbury Township",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Roxbury Township",
      "h2_subtitle": "Discover pet-friendly living at Parc at Roxbury, the perfect choice for those seeking dog park apartments in Roxbury Township.",
      "page_copy": "Welcome to Parc at Roxbury, where pet-friendly living meets modern comfort in Roxbury Township. Our community provides a welcoming environment for you and your furry friends, complemented by nearby access to local dog parks. While our property doesn't feature an on-site dog park, we are conveniently located near several community parks that are perfect for your pet's outdoor adventures.\n\nAt Parc at Roxbury, spacious one and two-bedroom apartments are designed with both style and practicality in mind. Enjoy modern amenities like Amazon Hub Lockers and a well-equipped fitness center, all within a lively, pet-friendly neighborhood. Experience the joys of a vibrant lifestyle with your four-legged companion by your side in the heart of Roxbury Township.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Roxbury Township",
      "seo_description": "Discover dog park-friendly living at Parc at Roxbury. Enjoy pet-friendly apartments with modern amenities in Roxbury Township.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-roxbury-township-254",
      "search_query": "one bedroom apartments roxbury township",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Roxbury Township",
      "h2_subtitle": "Discover spacious one-bedroom apartments at Parc at Roxbury. Enjoy modern living in the vibrant Roxbury Township community.",
      "page_copy": "Parc at Roxbury offers elegantly designed one-bedroom apartments that perfectly blend style and convenience in Roxbury Township. Tailored for comfort, these apartments provide all the modern amenities you need, including cable and satellite readiness and top-tier culinary appliances like a sleek wall oven and spacious refrigerator.\n\nBeyond your apartment, enjoy the vibrant lifestyle facilitated by amenities such as Amazon Hub Lockers, a state-of-the-art fitness center, and scenic walking trails. Situated in the heart of Roxbury Township, you'll have easy access to local attractions and a pet-friendly community environment. Make Parc at Roxbury your new home and experience the best of modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Roxbury Township",
      "seo_description": "Explore Parc at Roxbury's one-bedroom apartments in Roxbury Township. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-ledgewood-morris-county-163",
      "search_query": "two bedroom apartments ledgewood morris county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Ledgewood",
      "h2_subtitle": "Discover spacious two-bedroom apartments in Ledgewood at Parc at Roxbury. Experience comfortable living in scenic Morris County.",
      "page_copy": "Nestled in the scenic neighborhood of Ledgewood within Morris County, Parc at Roxbury proudly offers spacious two-bedroom apartments that promise a blend of elegance and practicality. These homes are perfect for those seeking a modern lifestyle, featuring deluxe amenities such as a wall oven, refrigerator, and cable and satellite readiness.\n\nBeyond the walls of your apartment, Parc at Roxbury offers a vibrant community atmosphere with features like Amazon Hub Lockers, a state-of-the-art fitness center, and beautiful outdoor trails ideal for leisurely walks. As a pet-friendly environment, your furry friends will feel right at home. Explore the advantages of living in this lively community and enjoy everything Ledgewood has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Ledgewood, NJ",
      "seo_description": "Find two-bedroom apartments in Ledgewood at Parc at Roxbury in Morris County. Enjoy modern living with fantastic amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-elementary-school-nj-91",
      "search_query": "apartments near Jefferson Elementary School NJ",
      "category": "School",
      "h1_title": "Apartments Near Jefferson Elementary School",
      "h2_subtitle": "Explore family-friendly apartments near Jefferson Elementary School at Parc at Roxbury, offering convenience and modern amenities.",
      "page_copy": "If you're searching for a family-friendly community close to Jefferson Elementary School in NJ, Parc at Roxbury is an ideal choice. Conveniently located, it ensures a short commute to the school, giving parents peace of mind with easy access to their child's education.\n\nOur community offers stylish one and two-bedroom apartments paired with modern amenities like Amazon Hub Lockers and a fully equipped fitness center, perfect for today's busy families. With scenic walking trails and a pet-friendly atmosphere, Parc at Roxbury provides a vibrant and supportive environment, making it the ideal setting for families prioritizing education and comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Elementary School",
      "seo_description": "Discover Parc at Roxbury's family-friendly apartments near Jefferson Elementary School NJ. Enjoy convenience and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "rental-homes-by-franklin-elementary-school-roxbury-388",
      "search_query": "rental homes by Franklin Elementary School Roxbury",
      "category": "School",
      "h1_title": "Rental Homes by Franklin Elementary School",
      "h2_subtitle": "Find convenient rental homes near Franklin Elementary School at Parc at Roxbury. Enjoy modern living in a welcoming community.",
      "page_copy": "Parc at Roxbury offers an exceptional living experience with rental homes ideally located near Franklin Elementary School in Roxbury. Perfect for families, our community ensures a quick and stress-free commute to the school, allowing you more time to enjoy life’s simple pleasures.\n\nOur rental homes feature stylish one and two-bedroom options with modern amenities like cable and satellite readiness and a wall oven-equipped kitchen. Beyond the comfort of your home, enjoy community perks such as a fitness center and scenic walking trails. Located in a lively neighborhood, Parc at Roxbury presents an ideal setting for families seeking a harmonious balance of convenience and modern living near Franklin Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Franklin Elementary School",
      "seo_description": "Explore Parc at Roxbury, offering rental homes near Franklin Elementary School in Roxbury. Experience modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-close-to-kennedy-elementary-school-morris-county-620",
      "search_query": "apartments close to Kennedy Elementary School Morris County",
      "category": "School",
      "h1_title": "Apartments Close to Kennedy Elementary School",
      "h2_subtitle": "Discover conveniently located apartments close to Kennedy Elementary School in Morris County at Parc at Roxbury.",
      "page_copy": "Looking for the perfect place near Kennedy Elementary School in Morris County? Parc at Roxbury offers beautiful one and two-bedroom apartments just a stone's throw away from the school. This prime location ensures a quick commute, making it an ideal choice for families who value education and convenience.\n\nOur residences feature modern comforts, including cable and satellite readiness, a wall oven, and more. Beyond these amenities, embrace community living with access to a state-of-the-art fitness center and scenic walking trails. Experience a mix of comfort, convenience, and community at Parc at Roxbury, where you'll find the perfect home close to Kennedy Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kennedy Elementary School NJ",
      "seo_description": "Discover Parc at Roxbury's apartments close to Kennedy Elementary School in Morris County. Enjoy convenience and modern living today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "parc-at-roxbury-near-lincoln-roosevelt-school-227",
      "search_query": "Parc at Roxbury near Lincoln Roosevelt School",
      "category": "School",
      "h1_title": "Parc at Roxbury Near Lincoln Roosevelt School",
      "h2_subtitle": "Explore comfortable living at Parc at Roxbury, conveniently located near Lincoln Roosevelt School, offering modern amenities and family-friendly features.",
      "page_copy": "Parc at Roxbury offers you a welcoming community just minutes from Lincoln Roosevelt School, making it a perfect location for families. Our modern one and two-bedroom apartments are crafted with style and convenience in mind, providing a great living environment close to quality education.\n\nThe community is packed with amenities such as a top-tier fitness center, Amazon Hub Lockers, and picturesque walking trails. Enjoy pet-friendly living in a thriving atmosphere, paired with the convenience of covered parking and EV charging station access. Make Parc at Roxbury your new home and delight in being part of a community that's as close to education as it is to comfortable, modern living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Parc at Roxbury Near Lincoln Roosevelt School",
      "seo_description": "Find modern living at Parc at Roxbury near Lincoln Roosevelt School. Enjoy convenient access and family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "rental-properties-near-eisenhower-middle-school-ledgewood-641",
      "search_query": "rental properties near Eisenhower Middle School Ledgewood",
      "category": "School",
      "h1_title": "Rental Properties Near Eisenhower Middle School",
      "h2_subtitle": "Find ideal rental properties near Eisenhower Middle School in Ledgewood at Parc at Roxbury, offering modern amenities in a prime location.",
      "page_copy": "Searching for rental properties in Ledgewood? Parc at Roxbury presents the perfect solution with our stylish one and two-bedroom apartments located conveniently near Eisenhower Middle School. This prime location ensures an easy commute for students, making it an excellent choice for families seeking proximity to education and community amenities.\n\nOur homes come adorned with modern finishes and convenient features, such as cable and satellite readiness and a wall oven-equipped kitchen. Beyond the comfort of your apartment, enjoy community delights like scenic walking trails, a state-of-the-art fitness center, and a lively pet-friendly vibe. Experience the balance of comfort and education-focused living at Parc at Roxbury, just a short distance from Eisenhower Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Properties by Eisenhower Middle School",
      "seo_description": "Discover Parc at Roxbury's rental properties near Eisenhower Middle School in Ledgewood. Enjoy modern living and educational convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-roxbury-high-school-07852-428",
      "search_query": "apartments near Roxbury High School 07852",
      "category": "School",
      "h1_title": "Apartments Near Roxbury High School",
      "h2_subtitle": "Explore apartments near Roxbury High School in the 07852 area at Parc at Roxbury, where convenience meets modern living.",
      "page_copy": "For families seeking apartments in the 07852 area, Parc at Roxbury offers an unbeatable location near Roxbury High School. Our stylish one and two-bedroom apartments are perfect for those who value accessibility to education and contemporary living.\n\nEach apartment is equipped with modern amenities, including cable and satellite readiness and wall ovens, ensuring a comfortable lifestyle. Residents enjoy a vibrant community atmosphere with access to a state-of-the-art fitness center, scenic walking trails, and pet-friendly spaces. Live with ease at Parc at Roxbury, where quality living blends seamlessly with top-tier education nearby.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Roxbury High School NJ",
      "seo_description": "Find modern apartments near Roxbury High School in the 07852 area at Parc at Roxbury. Enjoy convenience and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "parc-at-roxbury-near-american-christian-school-south-campus-663",
      "search_query": "Parc at Roxbury near American Christian School South Campus",
      "category": "School",
      "h1_title": "Parc at Roxbury Near American Christian School",
      "h2_subtitle": "Discover convenient living at Parc at Roxbury, located near American Christian School South Campus, offering modern amenities and a family-friendly environment.",
      "page_copy": "Parc at Roxbury is ideally situated close to the American Christian School South Campus, making it a prime choice for families seeking a convenient and nurturing environment. Our refined one and two-bedroom apartments provide a harmonious balance of comfort and style, perfect for those prioritizing easy access to educational facilities.\n\nResidents at Parc at Roxbury benefit from a range of modern amenities such as cable and satellite readiness, wall ovens, and Amazon Hub Lockers. The community also features a vibrant, pet-friendly atmosphere with scenic walking trails and a well-equipped fitness center. Close proximity to the South Campus ensures you're never far from quality education and neighborly warmth.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Parc at Roxbury by American Christian School",
      "seo_description": "Live near American Christian School South Campus at Parc at Roxbury. Enjoy modern living and educational convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-close-to-st-therese-school-roxbury-488",
      "search_query": "apartments close to St Therese School Roxbury",
      "category": "School",
      "h1_title": "Apartments Close to St Therese School",
      "h2_subtitle": "Find ideal living at Parc at Roxbury, with apartments close to St Therese School, combining modern amenities with educational convenience.",
      "page_copy": "If you're looking for apartments close to St Therese School in Roxbury, Parc at Roxbury offers an unbeatable option. Our thoughtfully designed one and two-bedroom apartments provide a perfect blend of contemporary style and comfort, ensuring families enjoy both convenience and community.\n\nIn addition to being near St Therese School, our residents benefit from modern features such as cable and satellite readiness and wall ovens. Recreational amenities like our state-of-the-art fitness center, scenic walking trails, and pet-friendly environment make Parc at Roxbury an ideal home. Experience seamless living with educational facilities just around the corner.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St Therese School Roxbury",
      "seo_description": "Discover Parc at Roxbury's apartments close to St Therese School in Roxbury. Enjoy modern comforts and educational convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "rental-homes-near-nixon-elementary-school-morris-county-314",
      "search_query": "rental homes near Nixon Elementary School Morris County",
      "category": "School",
      "h1_title": "Rental Homes Near Nixon Elementary School",
      "h2_subtitle": "Discover rental homes near Nixon Elementary School in Morris County at Parc at Roxbury, where modern living meets family-friendly amenities.",
      "page_copy": "Looking for rental homes near Nixon Elementary School in Morris County? Parc at Roxbury offers a superb option for families seeking proximity to education. Our one and two-bedroom apartments are designed with modern conveniences and style, perfect for those prioritizing both location and comfort.\n\nResidents of Parc at Roxbury enjoy state-of-the-art amenities, including a well-equipped fitness center, scenic walking trails, and pet-friendly spaces. Each home is cable and satellite ready, featuring wall ovens and Amazon Hub Lockers. With Nixon Elementary School nearby, families can enjoy a seamless balance of educational accessibility and contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Nixon Elementary School NJ",
      "seo_description": "Explore Parc at Roxbury's rental homes near Nixon Elementary School in Morris County, offering modern amenities and educational accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-county-college-of-morris-ledgewood-661",
      "search_query": "apartments near County College of Morris Ledgewood",
      "category": "School",
      "h1_title": "Apartments Near County College of Morris",
      "h2_subtitle": "Explore living at Parc at Roxbury, with apartments near County College of Morris in Ledgewood, offering modern amenities and academic convenience.",
      "page_copy": "Parc at Roxbury provides an excellent living choice for students and professionals seeking apartments near County College of Morris in Ledgewood. Our stylish one and two-bedroom homes offer the perfect mix of modern convenience and comfort, making them ideal for those who desire proximity to their studies.\n\nResidents enjoy a host of amenities including cable and satellite readiness, wall ovens, and Amazon Hub Lockers. With a state-of-the-art fitness center and scenic walking trails, the community is both lively and pet-friendly. Living near County College of Morris, you can enjoy academic ease while basking in the contemporary lifestyle offered at Parc at Roxbury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near County College of Morris",
      "seo_description": "Discover Parc at Roxbury's apartments near County College of Morris in Ledgewood, offering modern living and academic convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-saint-clares-dover-hospital-roxbury-township-738",
      "search_query": "apartments near Saint Clare's Dover Hospital Roxbury Township",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Clare's Dover Hospital",
      "h2_subtitle": "Find comfort and convenience at Parc at Roxbury, with apartments near Saint Clare's Dover Hospital in Roxbury Township.",
      "page_copy": "For those seeking apartments near Saint Clare's Dover Hospital in Roxbury Township, Parc at Roxbury offers a superb blend of location and amenities. Our modern one and two-bedroom apartments provide a comfortable living environment, ideal for medical professionals and hospital visitors alike.\n\nResidents benefit from contemporary amenities such as wall ovens, cable and satellite readiness, and on-site Amazon Hub Lockers. The community features a state-of-the-art fitness center, scenic walking trails, and a welcoming pet-friendly atmosphere. Experience hassle-free living and enjoy easy access to Saint Clare's Dover Hospital at Parc at Roxbury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Clare's Dover Hospital NJ",
      "seo_description": "Explore Parc at Roxbury's apartments near Saint Clare's Dover Hospital in Roxbury Township, combining comfort with essential convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-close-to-morristown-medical-center-morris-county-913",
      "search_query": "apartments close to Morristown Medical Center Morris County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Morristown Medical Center",
      "h2_subtitle": "Discover upscale living at Parc at Roxbury, with apartments close to Morristown Medical Center in Morris County, offering modern amenities and convenience.",
      "page_copy": "Parc at Roxbury provides an ideal living solution for medical professionals and visitors seeking apartments close to Morristown Medical Center in Morris County. Our one and two-bedroom homes offer stylish and contemporary comforts just a short distance from the hospital.\n\nEnjoy amenities such as a fitness center, courtyard, and convenient Amazon Hub Lockers. With cable and satellite readiness, along with wall ovens in each apartment, every detail is tailored for modern living. Experience a vibrant, pet-friendly environment with nearby scenic walking trails, all while being conveniently located near Morristown Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Morristown Medical Center",
      "seo_description": "Discover Parc at Roxbury's apartments close to Morristown Medical Center in Morris County, offering convenience and contemporary amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-horseshoe-lake-recreation-complex-roxbury-township-588",
      "search_query": "apartments near Horseshoe Lake Recreation Complex Roxbury Township",
      "category": "Park",
      "h1_title": "Apartments Near Horseshoe Lake Recreation",
      "h2_subtitle": "Enjoy living at Parc at Roxbury, with apartments near Horseshoe Lake Recreation Complex in Roxbury Township, offering active and modern amenities.",
      "page_copy": "Parc at Roxbury is the perfect choice for those seeking apartments near Horseshoe Lake Recreation Complex in Roxbury Township. Our one and two-bedroom apartments offer not only modern comforts but also proximity to a hub of outdoor activities.\n\nResidents enjoy a vibrant lifestyle with access to a state-of-the-art fitness center and scenic walking paths. Each home is equipped with conveniences like cable and satellite readiness, wall ovens, and Amazon Hub Lockers. The community is both pet-friendly and vibrant, making it an ideal place for those looking to balance active recreation with home comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Horseshoe Lake Recreation Complex",
      "seo_description": "Explore Parc at Roxbury's apartments near Horseshoe Lake Recreation Complex in Roxbury Township, ideal for modern living and outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "parc-at-roxbury-close-to-morris-canal-park-nj-597",
      "search_query": "Parc at Roxbury close to Morris Canal Park NJ",
      "category": "Park",
      "h1_title": "Parc at Roxbury Close to Morris Canal Park",
      "h2_subtitle": "Enjoy vibrant living at Parc at Roxbury, conveniently located close to Morris Canal Park in NJ, offering a blend of nature and modern comforts.",
      "page_copy": "Situated close to Morris Canal Park in NJ, Parc at Roxbury offers residents the luxury of living in a serene environment that combines nature and modernity. The one and two-bedroom apartments are designed for stylish and comfortable living, perfect for those who love outdoor activities while enjoying modern amenities.\n\nWith convenient access to scenic walking trails and a bustling community environment, residents enjoy features like a state-of-the-art fitness center and pet-friendly spaces. Our homes come equipped with wall ovens, cable readiness, and Amazon Hub Lockers. Experience a community that beautifully merges the tranquility of Morris Canal Park with contemporary living comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Parc at Roxbury Near Morris Canal Park NJ",
      "seo_description": "Discover Parc at Roxbury, located close to Morris Canal Park NJ, where modern living meets outdoor tranquility.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-riggs-canal-park-ledgewood-654",
      "search_query": "apartments near Riggs Canal Park Ledgewood",
      "category": "Park",
      "h1_title": "Apartments Near Riggs Canal Park",
      "h2_subtitle": "Find your home at Parc at Roxbury with apartments near Riggs Canal Park in Ledgewood, offering a blend of comfort and nature.",
      "page_copy": "Situated near the peaceful surroundings of Riggs Canal Park in Ledgewood, Parc at Roxbury offers the perfect haven for those seeking apartments that blend comfort with nature. Our one and two-bedroom homes provide residents with the best of both worlds: modern amenities and natural serenity.\n\nEnjoy features like a state-of-the-art fitness center, pet-friendly environment, and outdoor spaces ideal for walking and relaxation. Each apartment is equipped with conveniences like wall ovens, cable readiness, and Amazon Hub Lockers. Experience living where nature meets modernity, just a stone's throw from Riggs Canal Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riggs Canal Park Ledgewood",
      "seo_description": "Explore Parc at Roxbury's apartments near Riggs Canal Park in Ledgewood, offering modern amenities and access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "living-by-ledgewood-historic-park-roxbury-209",
      "search_query": "living by Ledgewood Historic Park Roxbury",
      "category": "Park",
      "h1_title": "Living by Ledgewood Historic Park",
      "h2_subtitle": "Experience the charm of living by Ledgewood Historic Park at Parc at Roxbury, combining elegance with historic charm in Roxbury.",
      "page_copy": "Discover a unique lifestyle at Parc at Roxbury, located near the charming Ledgewood Historic Park. This exceptional location offers residents the opportunity to enjoy the rich history of Roxbury while relishing modern living in our stylish one and two-bedroom apartments.\n\nSet in a vibrant community, the property features amenities including a state-of-the-art fitness center and pet-friendly environment. Each apartment is well-appointed with features such as wall ovens and cable readiness. Immerse yourself in a setting where the allure of history and the conveniences of modern living coalesce beautifully.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Ledgewood Historic Park Roxbury",
      "seo_description": "Enjoy living at Parc at Roxbury by Ledgewood Historic Park, blending modern amenities with historic charm in Roxbury.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "emmans-park-morris-county-nj-apartments-220",
      "search_query": "Emmans Park Morris County NJ apartments",
      "category": "Park",
      "h1_title": "Emmans Park Morris County NJ Apartments",
      "h2_subtitle": "Discover spacious apartments near Emmans Park in Morris County, NJ, at Parc at Roxbury, where comfort meets convenience.",
      "page_copy": "Nestled near Emmans Park in Morris County, NJ, Parc at Roxbury offers residents an ideal blend of spacious living and nature's tranquility. Our meticulously designed one and two-bedroom apartments provide a perfect haven for individuals and families seeking modern comforts alongside serene park views.\n\nResidents enjoy an array of amenities, including a state-of-the-art fitness center and pet-friendly spaces. With wall ovens, cable readiness, and Amazon Hub Lockers, each apartment ensures convenience and style. Embrace a lifestyle where the beauty of Emmans Park complements the elegance of your new home at Parc at Roxbury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Emmans Park Morris County NJ Apartments",
      "seo_description": "Explore Parc at Roxbury's apartments near Emmans Park in Morris County, NJ, offering modern amenities and scenic views.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "parc-at-roxbury-close-to-nalron-park-436",
      "search_query": "Parc at Roxbury close to Nalron Park",
      "category": "Park",
      "h1_title": "Parc at Roxbury Near Nalron Park",
      "h2_subtitle": "Enjoy proximity to Nalron Park when you choose Parc at Roxbury, offering modern living and natural beauty.",
      "page_copy": "Parc at Roxbury offers an exceptional living experience just a stone's throw from the serene Nalron Park. Here, residents are part of a community that values both modern conveniences and the soothing embrace of nature. Our one and two-bedroom apartments are ideal for those who enjoy an active lifestyle or simply appreciate nearby natural beauty.\n\nThe community features everything you need for comfortable living, including updated kitchens with wall ovens and ample storage. Stay connected with cable-ready units and enjoy the ease of Amazon Hub Lockers. Whether you’re taking a stroll in Nalron Park or working out in our fitness center, Parc at Roxbury ensures a lifestyle that honors both relaxation and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Parc at Roxbury Close to Nalron Park",
      "seo_description": "Live at Parc at Roxbury, close to Nalron Park, where modern life meets natural beauty, featuring top amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "near-black-river-park-parking-lot-apartments-383",
      "search_query": "near Black River Park Parking Lot apartments",
      "category": "Park",
      "h1_title": "Apartments Near Black River Park",
      "h2_subtitle": "Live near the Black River Park parking lot at Parc at Roxbury, and experience the perfect balance of nature and modern living.",
      "page_copy": "Experience the convenience of living near Black River Park's parking lot at Parc at Roxbury. Strategically located, our apartment community provides easy access to nature's delights while maintaining modern comforts. Ideal for those who love outdoor activities, Black River Park offers picturesque walking trails and beautiful scenery just minutes away.\n\nAt Parc at Roxbury, enjoy a variety of amenities designed for your lifestyle. Spacious one and two-bedroom apartments come equipped with the latest features, including wall ovens and cable readiness. Residents also benefit from Amazon Hub Lockers for easy package management. Choose Parc at Roxbury, where the beauty of Black River Park is right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Black River Park Parking Lot",
      "seo_description": "Find modern apartments near Black River Park's parking lot at Parc at Roxbury, offering natural beauty and contemporary amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-close-to-kiwanis-park-nj-762",
      "search_query": "apartments close to Kiwanis Park NJ",
      "category": "Park",
      "h1_title": "Apartments Close to Kiwanis Park NJ",
      "h2_subtitle": "Enjoy life near Kiwanis Park in NJ with Parc at Roxbury, offering stylish apartments and premium amenities.",
      "page_copy": "Discover the charm of living near Kiwanis Park in NJ at Parc at Roxbury. Our stylish one and two-bedroom apartments offer a perfect balance of comfort and convenience just minutes from this beloved local park. Ideal for those who love the outdoors, Kiwanis Park provides a serene escape with its lush landscapes and recreational opportunities.\n\nParc at Roxbury not only excels in location but also in the quality of amenities offered. Residents enjoy a fitness center, pet-friendly spaces, and modern kitchens featuring wall ovens. With cable-ready units and Amazon Hub Lockers, convenience is key. Embrace a life of modern living steps away from the natural allure of Kiwanis Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Kiwanis Park NJ",
      "seo_description": "Explore modern living at Parc at Roxbury, with apartments close to Kiwanis Park NJ, offering comfort and top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "parc-at-roxbury-and-hopatcong-state-park-apartments-369",
      "search_query": "Parc at Roxbury and Hopatcong State Park apartments",
      "category": "Park",
      "h1_title": "Parc at Roxbury Near Hopatcong State Park",
      "h2_subtitle": "Discover apartment living at Parc at Roxbury, ideally located near Hopatcong State Park's natural wonders and trails.",
      "page_copy": "Find your ideal home at Parc at Roxbury, where adventure meets comfort. Located close to Hopatcong State Park, our community is perfect for those who cherish outdoor activities like hiking, boating, or simply enjoying the breathtaking scenery. Parc at Roxbury offers luxurious one and two-bedroom apartments, catering to the needs of modern individuals and families alike.\n\nOur apartments feature contemporary amenities, such as wall ovens and cable readiness, ensuring you stay connected and entertained. Residents also benefit from the convenience of Amazon Hub Lockers. With a lively pet-friendly atmosphere and easy access to the trails and beauty of Hopatcong State Park, Parc at Roxbury is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Parc at Roxbury Near Hopatcong State Park",
      "seo_description": "Parc at Roxbury offers modern apartments near Hopatcong State Park, blending comfort with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166337",
      "source": "custom",
      "page_item_url": "apartments-near-newark-liberty-international-airport-932",
      "search_query": "apartments near Newark Liberty International Airport NJ",
      "category": "Transit",
      "h1_title": "Apartments Near Newark Liberty Airport NJ",
      "h2_subtitle": "Enjoy convenient living at Parc at Roxbury, just a short drive away from Newark Liberty International Airport NJ.",
      "page_copy": "Experience ultimate convenience at Parc at Roxbury, located within easy reach of Newark Liberty International Airport NJ. Perfect for frequent travelers, our community offers stylish one and two-bedroom apartments that combine comfort with accessibility. Enjoy a short drive to the airport while relishing the peaceful suburban charm of Roxbury Township.\n\nResidents can savor modern amenities, including state-of-the-art fitness facilities, ensuring a balanced lifestyle. Parc at Roxbury features EV charging stations and covered parking, addressing all your needs right from home. Choose Parc at Roxbury to enjoy a seamless blend of modern amenities and proximity to major travel hubs like Newark Liberty International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings with a swimming pool and parking lot.",
        "public_id": "01a015db-0c68-7361-b2cf-37c30b099afd",
        "storage_key": "property/6767906449166337/01a015db-0c68-7361-b2cf-37c30b099afd.webp",
        "width": 1920,
        "height": 1240
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Newark Liberty Airport NJ",
      "seo_description": "Find comfort and convenience at Parc at Roxbury, offering modern apartments near Newark Liberty International Airport NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5074"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976273620"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973423"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TXQP26DH"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://parcatroxbury.fatwin.com/api/websites/resources/1?x=dnlrK01OVE5jWmJSZFQ4YWcyNTZzdWpXRkpTN1AvY0RxVm91NE4rVmZibmNuWGZMczBQT1pGUmVZd09mOFcxZzhsNzFwNEZ0MlNvMmZ4bm5udEEvYnc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Stadium House"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8xvrkxdmwjk"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "954902b8-43e6-11ef-85fb-271e7d3db56c"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954902b8-43e6-11ef-85fb-271e7d3db56c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954902b8-43e6-11ef-85fb-271e7d3db56c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjdJUHVHa0tIekJ5ZjVNMDFkandKcGc9PSIsInZhbHVlIjoiSzFGZzNIakdtVEZEWWp6UEFKdk1xdz09IiwibWFjIjoiMGY0ODc3ZGRiMzJkYzg1ZjJjN2JiNzgzODIzODA2MDllOGRlMjdhZGI0ZDVlODI3MThlNDdhMmMzYjU0ZjI1MSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5074",
  "custom_repli_id": "9976273620",
  "custom_realpage_id": "4973423",
  "custom_google_gtm_id": "GTM-TXQP26DH",
  "custom_perq_script_url": "https://parcatroxbury.fatwin.com/api/websites/resources/1?x=dnlrK01OVE5jWmJSZFQ4YWcyNTZzdWpXRkpTN1AvY0RxVm91NE4rVmZibmNuWGZMczBQT1pGUmVZd09mOFcxZzhsNzFwNEZ0MlNvMmZ4bm5udEEvYnc9PQ2",
  "custom_vibesites_theme": "Stadium House",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/8xvrkxdmwjk",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "954902b8-43e6-11ef-85fb-271e7d3db56c",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954902b8-43e6-11ef-85fb-271e7d3db56c/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/954902b8-43e6-11ef-85fb-271e7d3db56c/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjdJUHVHa0tIekJ5ZjVNMDFkandKcGc9PSIsInZhbHVlIjoiSzFGZzNIakdtVEZEWWp6UEFKdk1xdz09IiwibWFjIjoiMGY0ODc3ZGRiMzJkYzg1ZjJjN2JiNzgzODIzODA2MDllOGRlMjdhZGI0ZDVlODI3MThlNDdhMmMzYjU0ZjI1MSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "c250914f-801b-410b-9e49-792df7e1b0c4",
  "custom_audioeye_site_hash": "f41d6414fcfa01f4a97c57c08bae9e04"
};

export const generatedAt = '2026-11-02T15:53:41.627Z';
